import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, NgZone, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { QuoteTemplateService } from 'src/app/quote-template-new/services/quote-template.service';
import { formatDisplayAddress } from 'src/app/shared/utils/format-display-address';
import { BusinessProfileService } from 'src/app/pages/business-profile/services/business-profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationViewService } from 'src/app/pages/contact-profile/view-organization/services/view-organization.service';
import { ProfileService } from 'src/app/pages/contact-profile/services/contact-profile.service';
import { ItemsService } from 'src/app/pages/items/services/items.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LeadService } from 'src/app/pages/lead/services/lead.service';
import { CustomDateFormatPipe } from 'src/app/shared/pipes/custom-date-format/custom-date-format.datepipe';
import { MatDatepicker } from '@angular/material/datepicker';
import { AnimationOptions } from 'ngx-lottie';
import SignaturePad from 'signature_pad';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { EditContactService } from 'src/app/pages/contact-profile/edit-contact/services/edit-contact.service';
import { DataService } from 'src/app/quote/quote-listing/contact-quote.service';
import { MatConfirmDeleteComponent } from 'src/app/Dialogs/mat-confirm-delete/mat-confirm-delete.component';
import { DecimalPipe } from '@angular/common';
import { ItemAddModel } from 'src/app/pages/items/model/item-add-model';
import { AddEditItemComponent } from 'src/app/pages/items/add-edit-item/add-edit-item.component';
import { taskReducer } from 'src/app/pages/tasks/reducers/task.reducer';
import { MatSelect } from '@angular/material/select';
import { SignaturePadComponentCreate } from 'src/app/quote/signature-pad/signature-pad.component';
import { MatTabGroup } from '@angular/material/tabs';
import { v4 as uuidv4 } from 'uuid';
import { templateNotSavingComponent } from 'src/app/Dialogs/template-not-save/template-not-save.component';
import * as moment from 'moment';
import { PermissionService } from 'src/app/services/permission.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SentryService } from 'src/app/core/services/sentry.service';
import { FormulaRuntimeService } from 'src/app/shared/formula/formula-runtime.service';
import { LoggerService } from 'src/app/services/logger.service';
import {
  flattenQuoteTermsForAccept,
  ensureQuoteTermsElementShape,
  getQuoteTermsCheckboxSizePx,
  getQuoteTermsCheckmarkSizePx,
  getQuoteTermsCheckboxGlyph,
  hasActiveQuoteTerms,
  isQuoteTermsAcceptanceComplete,
  normalizeContractLinkUrl,
  QUOTE_TERMS_CONDITIONS_ELEMENT_NAME,
  QuoteTermsContractLink,
  QuoteTermsAcceptContext,
} from 'src/app/quote/models/quote-terms-conditions.util';

export interface PeriodicElement {
  id:any;
  item: any;
  quantity: string;
  price: any;
  discount: string;
  discPrice: any;
  totalPrice: any;
  category: string;
  subCategory: string;
  itemsComing: any;
  weight: any;
  delete:any;
  picture:any;
  stockStatus:any;
  totalCost: any;
  salesCommission: any;
  profitMargin: any;
  isMerged?: boolean;
}

const ELEMENT_DATA: PeriodicElement[] = [];
@Component({
    selector: 'app-new-tmp',
    templateUrl: './new-tmp.component.html',
    styleUrls: ['./new-tmp.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class NewTmpComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('signaturepad') signaturepad: any;
  isSignatureEmpty: boolean = true;
  cardExpiry:any;
  stripeDataKeys:any;
  private _stripeInitialized = false;
  // In-flight promise for lazily ensuring the Stripe.js SDK global is loaded (see ensureStripeSdk).
  private stripeSdkPromise: Promise<void> | null = null;
  cardCvc:any;
  cardValid = false;
  expiryValid = false;
  cvcValid = false;
  selectedTabIndex: any = 0;
  paymentPage: boolean = false;

  formulaFieldSums: any[] = [];


  showUnselect: boolean = false;
  debitCardForm: FormGroup;
  isSlideToggled: boolean = true;
  isItemDisable:boolean = true
  isSlideQuantity: boolean = false;
  modifyPrice:boolean = false;
  receivedData:any
  transferForm: FormGroup;
  profit: number = 0
  paymentMethod = 'bank';
  options: AnimationOptions = {    
    path: "../../../assets/lottie/main_dp.json"
  };
  
   update_id
  private _unsubscribeAll: Subject<any> = new Subject();
  @ViewChild('formContent') formContent: ElementRef;
  @ViewChild('signaturePadCanvas') signaturePadCanvas: ElementRef;
  @ViewChild('quoteCurrency') quoteCurrency: ElementRef;
  @ViewChild('salesTaxSelect') salesTaxSelect: ElementRef;

  selectedDate: Date | string;
  sentDate:any;
  infoMsg:any=''
  rottenDays:boolean=false;
  afterDiscount:any=0
  newDiscount:any;
  newPriceA:any;
  aftertax:any=0
  totalCost:any=0
  profitmargin:any=0
  showThankYouDialog:any;
  salesCommission:any=0
  itemCategoryId:any;
  newItemData:any;
  itemNewId:any;
  afterDiscount1:any=0
  aftertax1:any=0
  applyDiscount:any;
  totalCost1:any=0
  profitmargin1:any=0
  salesCommission1:any=0
  public profitMargn:any = 0
  ownername:any;
  selectedPriceA:any;
  rateValue:any;
  itemsListArr:any=[];
  viewByMe:any;
  contactView:any;
  contactSince:any;
  addedItemsData:any[]=[];
  savedSignatureDataUrl: string | null = null;
  tableData: string[][] = [];
  rowsArray: any[];
  sendMailDate:any;
  quoteListingData:any;
  htmlContent: string = '';
  actpageIndx: number = 0;
  headerData: string[] = [];
  currencyArr:any;
  userEmail:any;
  isMobile: boolean = false;
  showCurrencySymbol:any;
  showCurrencySymbolExchange:any;
  paymentsData: any[] = [];
  remainingAmount: any = '';
  paymentDisplayedColumns = [
    { name: 'Title', key: 'title' },
    { name: 'Date', key: 'paymentDate' },
    { name: 'Method', key: 'paymentMethod' },
    { name: 'Amount', key: 'paymentAmount' },
    { name: '%', key: 'percentage' },
    { name: 'Status', key: 'paymentStatus' },
  ];
  pricesArrayNew:any
  dataSource=ELEMENT_DATA;
  selectedCurrency:any;
  quoteSentDate:any
  creationDate:boolean=false;
  currentQuantity: number = 1;
  initialQuantity: number = 1;
  headerData1: string[] = [
    'Item name',
    'Item code',
    'Item image',
    'Video URL',
    'Website URL',
    'Custom item fields',
    'Description',
    'Item comments',
    'Item Unit',
    'Quantity',
    'Item price',
    'Tax Exempt indicator',
    'Currenccy',
    'Discount',
    'Applicable taxes',
    'Quote ID',
    'Invoice ID',
    'Sales Order ID',
    'Price',
    'Total',
  ];
  selectedRowCount: number = 3;
  selectedColumnCount: number = 3;
  addressArr: any;
  staticLogo: string =
    'https://osmos-bucket-prod.s3.us-east-1.amazonaws.com/upload_note_attachment/1699445669424_placeholder_logo.png';
  contactId: any;
  widgetsPanel: boolean = false;
  userProfilePic: any;
  pricePanel: boolean = false;
  inforDropdown: boolean = false;
  addPrices: boolean = false;
  tableStyleClass = 'table-style-default'

  tagsList = [
    { item: 'Design' },
    { item: 'Website' },
    { item: 'UI/UX' },
    { item: 'Dashboard' },
    { item: 'Awesome' },
  ];
  currenciesList = [
    { item: 'USD' },
    { item: 'EUR' },
    { item: 'Pound' },
    { item: 'Pkr' },
  ];
  selectedCurrencyDeafult = this.currenciesList[0]?.item;
  // dataSource: any = [];
  columnsToDisplay = [
    'item',
    'quantity',
    'weight',
    'price',
    'discount',
    'discPrice',
    'totalPrice',
  ];
  columnsToDisplayWithExpand :any ;
  expandedElement: PeriodicElement | null;
  slectedPrice: any;
  selectedDiscount: any;
  fixCostUnit:any;
  sales_comm_type:any;
  sales_commission:any;
  itemPrices: any;
  newAddress = [];
  newAddressbui = [];
  dealDescription = [];
  newAddressorg = [];
  workSpaceData: any;
  newPhone = [];
  newPhoneorg = [];
  newPhonebui = [];
  selectedPrice: any = '';
  newEmail = [];
  globalSearchText = '';
  sortField: any = 'created_at';
  sortOrder: any = 'DESC';
  selectedStore: any;
  lengthValue: number = 10;
  widthValue: number = 5;
  orgList: any;
  totalValue: any;
  merchantContactData: any;
  merchantQuoteData: any;
  contactProfilePic: any;
  viewOrganizationArr: any;
  orgName: any;
  where: any = [];
  socialLinks: any;
  imageURL1: any;
  serchArr: any;
  staticLogo2: string;
  // update_id:any='';
  itemData: any;
displayedColumnsKeys: string[] ;

  customerLeadDetailsArr: any;
  itemDeletedata: any;
  formattedSelectedDate:any;
  dropListData = [
    {
      page: 'page00',
      items: [],
    },
    // Add more pages as needed
  ];
  dateValue:any
  showAllAddresses: boolean = false;
  @ViewChild('temp_ref') temp_ref: ElementRef;
  itemCount = 10;
  nextPageNumber: number = 1;
  pages: any[] = ['page00'];
  tables: { name: any; data: any[] }[] = [];
  public imageUrl = environment.IMAGE_BACKET_URL;
  subscriptions: Subscription[] = [];
  crSymbol:any;
  crCode: any;
  hideCurrencyCode: boolean = false;
  addressesToShow: number = 2;
  showCanvas = false;
  formContactList:any;
  private signaturePad: SignaturePad;
  textContent: string = 'Show more';
  isExpanded: boolean = false;
  initialDescriptionLength: number = 30;
  merchantId: string;
  businessDataArr: any;
  showPhones: boolean = false;
  userName = new FormControl('', [Validators.required]);
  agreementChecked = new FormControl(false,[Validators.required]);
  hasTemplateTerms = false;
  quoteTermsFieldStyles: any[] = [];
  quoteTermsRows: QuoteTermsAcceptContext[] = [];
  termsChecked: Record<string, boolean> = {};
  termsValidationAttempted = false;
  private acceptProcessing = false;
  private componentDestroyed = false;
  private _destroyed = false;
  private acceptTimerIds: ReturnType<typeof setTimeout>[] = [];
  chequeImage: string = '../../../assets/icons/cheque_black.png';
  otherImage: string = '../../../assets/icons/cheque.png';
  clearSignatureValue = null;
  // Add this method to track elements in ngFor
  trackByFn(index: number, item: any): any {
    return index;
  }

  subCategoryName = 'Motor Car';
  categoryName = 'Cars';
  itemAddModel = new ItemAddModel();
  @ViewChild(MatSelect) select: MatSelect;
  newItemPriceList:any={pricesA: '', pricesB: '', pricesC: '', pricesD: ''} ;
  itemPriceList = {pricesA:'1000.00', pricesB: '800.00',pricesC:'600.00',pricesD:'500.00'};
  newPrice = new FormControl('');
  allTaxesList = [{taxData:{name:'Hs',customValueId:1},taxe_value:'10'},{taxData:{name:'Va',customValueId:2},taxe_value:'5'}]
  addDiscountsArr = [];
  addItemPriceTaxArr=[];
  inputData = {cost:'500',profitMargin:'40.4',salesCommission:'70'};
  lenghtValue = 5;
  width_Value = 8;
  @ViewChild('signaturePad') signaturePads!: SignaturePadComponentCreate;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  constructor(
    public dialogRef: MatDialogRef<NewTmpComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dailogData: any,
    public router: Router,
    private sanitizer: DomSanitizer,
    public quoteTemplateService: QuoteTemplateService,
    public dialog: MatDialog,
    private dataService: DataService,
    private _router: Router,
    public QuoteTemplateServices: QuoteTemplateService,
    private businessProfileService: BusinessProfileService,
    private organizationservice: OrganizationViewService,
    private profileService: ProfileService,
    private itemsService: ItemsService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private datePipe: CustomDateFormatPipe,
    public leadService: LeadService,
    private spinnerService: NgxSpinnerService,
    private translateService: TranslateService,
    private editContactService: EditContactService,
    private decimalPipe: DecimalPipe,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2, private el: ElementRef,
    private permissionService: PermissionService,
    private snackbar: MatSnackBar,
    private sentryService: SentryService,
    private formulaRuntime: FormulaRuntimeService,
    private logger: LoggerService,
  ) { 
    this.checkMobile();
    if (this.isMobile && (this.dailogData?.type == 'Quote preview' || this.dailogData?.type == 'view')) {
      this.dialogRef.addPanelClass('new-tmp-dialog');
    }
    this.initForm();
    this.agreementChecked = new FormControl(false);
    this.initQuoteTermsAcceptance();
  }

  private initQuoteTermsAcceptance(): void {
    if (this.dailogData?.type !== 'User Confirm' || !this.dailogData?.field_styles) {
      return;
    }
    this.quoteTermsFieldStyles = Array.isArray(this.dailogData.field_styles)
      ? this.dailogData.field_styles
      : [];
    for (const page of this.quoteTermsFieldStyles) {
      for (const item of page?.items || []) {
        if (item?.name === QUOTE_TERMS_CONDITIONS_ELEMENT_NAME) {
          ensureQuoteTermsElementShape(item);
        }
      }
    }
    this.hasTemplateTerms = hasActiveQuoteTerms(this.quoteTermsFieldStyles);
    this.quoteTermsRows = flattenQuoteTermsForAccept(this.quoteTermsFieldStyles);
    this.termsChecked = {};
    for (const row of this.quoteTermsRows) {
      this.termsChecked[row.term.id] = false;
    }
  }

  getQuoteTermContractLinkHref(contractLink: QuoteTermsContractLink): string {
    return normalizeContractLinkUrl(contractLink?.url || '');
  }

  getQuoteTermsCheckboxSize(fontSize: string | number): number {
    return getQuoteTermsCheckboxSizePx(fontSize);
  }

  getQuoteTermsCheckmarkSize(fontSize: string | number): number {
    return getQuoteTermsCheckmarkSizePx(fontSize);
  }

  getQuoteTermsCheckboxGlyph(term: { selected?: boolean }): string {
    return getQuoteTermsCheckboxGlyph(term);
  }

  toggleQuoteTerm(row: QuoteTermsAcceptContext): void {
    this.termsChecked[row.term.id] = !this.termsChecked[row.term.id];
  }

  isQuoteTermChecked(row: QuoteTermsAcceptContext): boolean {
    return !!this.termsChecked[row.term.id];
  }

  hasUncheckedRequiredQuoteTerms(): boolean {
    return !isQuoteTermsAcceptanceComplete(this.quoteTermsFieldStyles, this.termsChecked);
  }

  canAcceptQuote(): boolean {
    const hasSignatureOrName =
      this.savedSignatureDataUrl != null || !this.userName.hasError('required');
    if (this.hasTemplateTerms) {
      return hasSignatureOrName && !this.hasUncheckedRequiredQuoteTerms();
    }
    return hasSignatureOrName && !!this.agreementChecked.value;
  }

  trackQuoteTermById(_index: number, row: QuoteTermsAcceptContext): string {
    return row.term.id;
  }
  title: string;
  newtemFrom: FormGroup;
  addQuoteStageForm: FormGroup;
  newtemSubmit: boolean = false;
  leadTags = Array();
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  searchItem: FormControl = new FormControl();
  filteredOptionsClauses: any[] = [];
  clausesSave: any[] = [];
  addOnBlur: boolean = true;
  removable: boolean = true;
  selectable: boolean = true;
  updatetemp_id: any;
  submitType:string='';
  permission
  stripe: any;
  elements: any;
  errorMessage: any;
  card: any;
  stripeToken: any;
  // Start disabled: the credit PAY button stays off until the Stripe card fields are valid.
  // Defaulting to true (instead of flipping it to true in ngAfterViewInit/initializeStripe)
  // avoids NG0100 ExpressionChangedAfterItHasBeenChecked on the [disabled] binding.
  buttonDisabled = true;
  updatedPaymentData
  // setPaymentFields() {
  //   if (this.dailogData?.type === 'payment') {
  //     this.stripeDataKeys=this.dailogData?.stripeData
  //     console.log(this.stripeDataKeys,'this.stripeDataKeys22222')
  //     const paymentsMethod = this.dailogData.paymentsData?.paymentMethods; 
  //     console.log(paymentsMethod,'paymentsMethodpaymentsMethod')
  //     // Loop through all paymentsData objects
  //     this.dailogData.paymentsData?.paymentsData.forEach(payment => {
  //       if (payment?.checked) {
         
  //         const matchingMethod = paymentsMethod.find(method => method.name === payment?.paymentMethod);
  //          if (matchingMethod?.name == 'Stripe (Credit Card)') {
  //            this.paymentMethod = 'credit';
  //          } else if (matchingMethod?.name == 'Mastercard') {
  //            this.paymentMethod = 'Master';
  //          } else if (matchingMethod?.name == 'Bank Account') {
  //            this.paymentMethod = 'bank';
  //          } else if (matchingMethod?.name == 'Cash') {
  //            this.paymentMethod = 'cash';
  //          } 
  //          else if (matchingMethod?.name == 'Visa') {
  //           this.paymentMethod = 'Visa';
  //         }
  //         else {
  //            this.paymentMethod = matchingMethod?.name;
  //          }
  //         if (matchingMethod) {
  //           // Ensure 'methods' array exists in payment object and clear it to prevent duplication
  //           payment.methods = payment.methods || []; // Initialize if not already present
  //           payment.methods = [];  // Clear any previously added methods to avoid duplication
  
  //           // Push the matching method into the methods array
  //           payment.methods.push(matchingMethod);
  //         }
  //       }
  //     });
  
  //     this.updatedPaymentData = this.dailogData.paymentsData?.paymentsData;
  //   }
  // }
  
  unmatchedMethods =[];
  async setPaymentFields(): Promise<void> {
    return new Promise((resolve, reject) => {
        try {
            if (this.dailogData?.type === 'payment') {
                this.stripeDataKeys = this.dailogData?.stripeData;
                // console.log(this.stripeDataKeys, 'this.stripeDataKeys22222');
                // console.log(this.dailogData, 'mmmmmmmmm22222222222');

                const paymentsMethod = this.dailogData.paymentsData?.paymentMethods;
                console.log(paymentsMethod, 'paymentsMethodpaymentsMethod');

                // Initialize an array to store unmatched methods
                this.unmatchedMethods = [];

                // Mark which payments are due now (by date). Every distinct due-now method then
                // gets its own selectable button; the customer taps one to pay that method's
                // amount (card = charged via Stripe; Cash/Bank = shown for reference, collected
                // offline). Replaces the old, often-unset payment.checked flag.
                for (let i = 0; i < this.dailogData.paymentsData?.paymentsData?.length; i++) {
                    const payment = this.dailogData.paymentsData.paymentsData[i];
                    payment.checked = this.isPayableNow(payment);
                    if (payment.checked) {
                        const matchingMethod = paymentsMethod?.find(method => method.name === payment?.paymentMethod);
                        // Custom (non-built-in) methods: keep their fields so their form can render.
                        if (matchingMethod &&
                            !['Stripe (Credit Card)', 'Mastercard', 'Bank Account', 'Cash', 'Visa'].includes(matchingMethod.name)) {
                            this.unmatchedMethods.push({ name: matchingMethod.name, fields: matchingMethod.fields || [] });
                        }
                        if (matchingMethod) {
                            payment.methods = [matchingMethod];
                        }
                    }
                }

                this.updatedPaymentData = this.dailogData.paymentsData?.paymentsData;

                // Default the active method to a card (so the card form is ready to pay) when one
                // is due now, otherwise the first due-now method. paymentMehtod() sets the method,
                // its per-method amount, and mounts the Stripe card fields when applicable.
                const duePayments = (this.updatedPaymentData || []).filter((p: any) => p?.checked);
                const defaultPayment = duePayments.find((p: any) => p?.paymentMethod === 'Stripe (Credit Card)') || duePayments[0];
                if (defaultPayment) {
                    this.paymentMehtod(this.methodTypeForName(defaultPayment.paymentMethod));
                }

                resolve(); // Resolve the promise when done
            } else {
                resolve(); // Resolve even if no action is taken
            }
        } catch (error) {
            console.error('Error in setPaymentFields:', error);
            reject(error); // Reject the promise on error
        }
    });
}

  
  
  
  async ngOnInit(): Promise<void> {
    this._destroyed = false;
    this.componentDestroyed = false;
    this.quoteDialogCloseStarted = false;
    this.checkMobile();
    // Build the card form BEFORE setPaymentFields(), which can set paymentMethod='credit' and
    // render the [formGroup]="debitCardForm" credit form. If the group isn't created first,
    // Angular throws NG01052 ("formGroup expects a FormGroup instance").
    this.createForm();
    if(this.dailogData?.type =='payment'){
      this.updatedPaymentData=[]
      await this.setPaymentFields();
      // console.log(this.dailogData,'jjjjjjjjjjj33')
    }
    this.permission = this.permissionService?.retrivePermission();
   
    this.leadService.currencySymbal$.subscribe((res: any) => { this.crSymbol = res; });
    this.leadService.currencyCode$.subscribe((res: any) => { this.crCode = res; });
    this.leadService.hideCurrencyCode$.subscribe((res: any) => { this.hideCurrencyCode = res; });
    this.savedSignatureDataUrl = null
    this.addNewTemForm();
    this.title = this.dailogData?.title;
    if(this.dailogData.type =='quote'){
      if(this.dailogData?.element?.fulldata){
        this.categoryName = this.dailogData?.element?.fulldata?.category?this.dailogData?.element?.fulldata?.category:'';
        this.subCategoryName =this.dailogData?.element?.fulldata?.subCategory?this.dailogData?.element?.fulldata?.subCategory:'';
        
      }
      this.editItemList(this.dailogData.id)
    }
    if (this.dailogData.type === "clone" || this.dailogData.type === "edit" || this.dailogData.type === "duplicate") {
      this.patchForm(this.dailogData);
    }
    // createForm() moved to the top of ngOnInit so debitCardForm exists before the credit form renders.
    this.transferForm = this.fb.group({
      transferType: ['', Validators.required],
      accountNumber: ['', Validators.required],
      bankName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      beneficiary: ['', Validators.required]
    });
    if(this.dailogData?.type == 'Quote preview' || this.dailogData?.type == 'view'){

      document.addEventListener("DOMContentLoaded", function() {
        const parentDiv = document.getElementById("parentId");
        if (parentDiv) {
            const elements = parentDiv.querySelectorAll("*");
            elements.forEach((element: HTMLElement) => {
                element.setAttribute("readonly", "true");
            });
        }
    });
   
    
    
    if(this.dailogData.field_styles){
      let field_list = this.dailogData.field_styles
      if (this.pages.indexOf(field_list?.page) === -1) {
        this.pages.push(field_list.page);
      }
      const mappedItems = field_list.map((y) => {
        return {
          page: y.page,
          items: y.items,
          field_order: y.field_order,
        };
        
      });
      
      // mappedItems.sort((a, b) => a.field_order - b.field_order);
      this.dropListData = mappedItems;
      
      this.dropListData.forEach((item) =>{
        
        item.items.forEach(async (item2)=>{
        
          
          if(item2.name =='Item Table'){

            if(item2.class_name){
              this.tableStyleClass = item2.class_name
            }
            
            this.tables=item2.table
            this.columnsToDisplayWithExpand =[...item2?.displayedColumns11]
            this.columnsToDisplayWithExpand = [...this.columnsToDisplayWithExpand];
  
          }

          if (item2.name === 'Clauses') {
            if (item2.fruits?.length) {
              this.clausesSave = item2.fruits;
            }
            this.filteredOptionsClauses = item2?.custom_value?.value || [];
            if (this.clausesSave?.length) {
              item2.fruits = this.clausesSave;
            } else if (!item2?.fruits?.length) {
              item2.fruits = [];
            }
          }

          if (item2.name === 'Payment') {
            this.paymentDisplayedColumns = [
              { name: item2?.Title || 'Title', key: 'title' },
              { name: item2?.Date || 'Date', key: 'paymentDate' },
              { name: item2?.Method || 'Method', key: 'paymentMethod' },
              { name: item2?.Amount || 'Amount', key: 'paymentAmount' },
              { name: item2?.Percentage || 'Percentage', key: 'percentage' },
              { name: 'Status', key: 'paymentStatus' },
            ];

            if (item2?.paymentsData?.length) {
              this.paymentsData = [...item2.paymentsData].sort((a, b) => {
                const dateA = new Date(a.paymentDate || a.selectedDate).getTime();
                const dateB = new Date(b.paymentDate || b.selectedDate).getTime();
                return dateA - dateB;
              });
              item2.paymentsData = this.paymentsData;
            } else {
              this.paymentsData = [];
            }
          }
          
          
          // this.displayedColumnsKeys = this.columnsToDisplayWithExpand.map(column => column.name)
          // console.log(this.displayedColumnsKeys,'wwwwwwwwwwww');
         
    // this.columnsToDisplay = this.columnsToDisplay
        })
      })
      if (this.dailogData?.remainingAmount !== undefined && this.dailogData?.remainingAmount !== null) {
        this.remainingAmount = this.dailogData.remainingAmount;
      }
      if (this.dailogData?.showCurrencySymbol) {
        this.showCurrencySymbol = this.dailogData.showCurrencySymbol;
      }
      if (this.dailogData?.showCurrencySymbolExchange) {
        this.showCurrencySymbolExchange = this.dailogData.showCurrencySymbolExchange;
      }
      document.addEventListener("DOMContentLoaded", function() {
        const parentDiv = document.getElementById("parentId");
        if (parentDiv) {
            const elements = parentDiv.querySelectorAll("*");
            elements.forEach((element: HTMLElement) => {
                element.setAttribute("readonly", "true");
            });
        }
    });
      // this.sourceOfContact()
      // this.leadService.currencySymbal$.subscribe((res: any) => { this.crSymbol = res; console.log(res,'nnnnnjjjjj') });
    }
   
    }
    


    if(this.dailogData?.type=='Quote stage'){
      if (!this.permission?.includes('quoteStage_create')) {
        this._router.navigate(['/dash']);
      }else{
        console.log(this.dailogData?.data?.rotting_days,'this.dailogData?.data?.rotting_days');
        
        if(this.dailogData?.data?.rotting_days || this.dailogData?.data?.rotting_days==0){
          this.rottenDays=true
        }
        this.addQuoteStageForm.patchValue(this.dailogData?.data);

      }
    }
  }

 

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkMobile();
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
    console.log(this.isMobile, 'isMobile state updated');
  }

  handleCardChange(event: any, field: string): void {
    if (field === 'card') {
      this.cardValid = event.complete;
    } else if (field === 'expiry') {
      this.expiryValid = event.complete;
    } else if (field === 'cvc') {
      this.cvcValid = event.complete;
    }

    // Update button state
    this.buttonDisabled = !(this.cardValid && this.expiryValid && this.cvcValid);
  }

  initForm(){
    this.addQuoteStageForm=this.fb.group({
      name:['',Validators.required],
      color:['',Validators.required],
      order:[''],
      rotting_days:[''],
    })
  }

  clearSignature(): void {
    this.signaturePads.clearSignature();
    this.isSignatureEmpty = true;
  }

 

  ngOnChanges(changes: SimpleChanges): void {
    // paymentMethod is not an @Input, so this check was unused.
    // Initialization is now managed in ngAfterViewInit and setPaymentFields.

   
    
    if (changes.clearValue && changes.clearValue.currentValue === 'clear') {
     this.clearSignatureValue = 'null'
    } else {
      this.clearSignatureValue = 'clear'
    }
    const paginationButton = this.tabGroup._elementRef.nativeElement.querySelector('.mat-tab-header-pagination-after');
   
   // Attach a click event listener to the pagination button
   this.renderer.listen(paginationButton, 'click', () => {
     // Check if the window width is less than or equal to 425
     if (window.innerWidth <= 425) {
      
       this.selectedTabIndex+1
       // Add your logic to increase the tab here
     }
   });
  }

  getSafeHtml(htmlString: string): SafeHtml {
    const decodedHtml = decodeURIComponent(htmlString);
    const trustedHtml = this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
    return trustedHtml;
  }


  getFormData(item: any): any {
    const embedFrom = item?.data?.quotes_templates_new_fields;
    if (embedFrom) {
      return {
        data: embedFrom?.map((el: any) => el?.field_styles),
        style: {
          color: embedFrom[0]?.field_styles?.colors,
          font_family: embedFrom[0]?.field_styles?.fontFamily,
          font_size: {
            head: embedFrom[0]?.field_styles?.headingSize,
            body: embedFrom[0]?.field_styles?.bodySize,
            helptxt: embedFrom[0]?.field_styles?.helpTextSize
          },
          logo:embedFrom[0]?.field_styles?.imageURL
        }
      }
    }
  }

  newtemFormValue() {
    this.newtemSubmit = true;
    if (this.newtemFrom?.invalid) {
      return;
    }
    this.newtemFrom?.controls['quotes_template_tags'].setValue(this.leadTags);
    if (this.dailogData.type === "create" ||
      this.dailogData.type === "clone" ||
      this.dailogData.type === "default" ||
      this.dailogData.type === "duplicate"|| 
      this.dailogData.type === "view" ||
      this.dailogData.type === "preview") 
      
      {
      this.create_Lead_Form_Value();
    }
    if (this.dailogData.type === "edit") {
      this.update_Lead_Form_Value();
    }
  }

  create_Lead_Form_Value() {
    const fields = this.dailogData?.data?.quotes_templates_new_fields.map((el:any)=>{return {
      field_name:el?.field_name,
      field_type:el?.field_type,
      field_order:el?.field_order,
      field_styles:el?.field_styles
    }});
    const payload = {
      ...this.newtemFrom.value,
      template_sub_types: 'custom',
      template_types:'Quote',
      html: this.dailogData?.data?.html ? this.dailogData?.data?.html : '',
      quotes_templates_new_fields: fields!==undefined?fields:[],
    };
    const tags = this.extractTags(payload.quotes_template_tags);
    if (tags.length > 0) {
      payload.quotes_template_tags = tags;
    }
    console.log(payload,'payload')  
    this.quoteTemplateService.create_Lead_Form(payload).subscribe(
      (res: any) => {
        if (res) {
          this.dialogRef.close();
          if(this.dailogData?.type1 =='quote_listing'){
            this.router.navigate([`dash/quote-template/formbuilder/${res?.data.id}`], { queryParams: { data: this.dailogData?.type1,selectedContact:this.dailogData?.type2 } });

          }else{
            this.router.navigate([`dash/quote-template/formbuilder/${res?.data.id}`])
          }
        }
      },
      (error) => {
      }
    );
  }
  
  extractTags(quotesTemplateTags) {
    if (!quotesTemplateTags || !quotesTemplateTags.length) {
      return [];
    }
  
    return quotesTemplateTags
      .filter((tag) => tag.name)
      .map((tag) => ({ name: tag.name }));
  }
  

  update_Lead_Form_Value() {
    const payload = { ...this.newtemFrom.value, 
      id: this.updatetemp_id, 
      template_description:'',  
      quotes_templates_new_fields: [], 
      otherFields:{}, 
    }; 
    
    this.quoteTemplateService.update_Lead_Form(payload).subscribe((res: any) => {
      if (res) {
        this.dialogRef.close(this.submitType);
        if(this.submitType === 'update'){
          this.router.navigate([`dash/quote-template`]);
        }
        if(this.submitType === 'edit'){
          this.router.navigate([`dash/quote-template/formbuilder/${this.updatetemp_id}`]);
        }
      }
    }, (error) => { });
  }

  addNewTemForm() {
    this.newtemFrom = this.fb?.group({
      template_name: ['', Validators.required],
      // lable: ['', Validators.required],
      quotes_template_tags: ['']
    });
  }

  get newtemVal() {
    return this.newtemFrom?.controls;
  }

  add(event: MatChipInputEvent): void {
    const input = event?.input;
    const value = event?.value;
    if ((value || '').trim()) {
      const trimmedValue = value.trim();
      const isDuplicate = this.leadTags.some(tag => tag.name === trimmedValue);
      if (!isDuplicate) {
        this.leadTags.push({ name: trimmedValue });
      }
    }
    if (input) {
      input.value = '';
    }
  }

  remove(fruit): void {
    const index = this.leadTags.indexOf(fruit);
    if (index >= 0) {
      this.leadTags.splice(index, 1);
    }
  }

  patchForm(data: any) {
    this.newtemFrom.patchValue({
      template_name: data?.data?.template_name,
      quotes_template_tags: data?.data?.quotes_template_tags?.map((el: string) => { return { name: el } })
    });
    this.leadTags = data?.data?.quotes_template_tags;
    this.updatetemp_id = data?.data?.id;
  }


  paymentView() {
    if (this.componentDestroyed) {
      this.acceptProcessing = false;
      return;
    }
    if (this.acceptProcessing) {
      return;
    }
    if (!this.canAcceptQuote()) {
      this.acceptProcessing = false;
      this.termsValidationAttempted = true;
      return;
    }
    this.acceptProcessing = true;
    this.paymentPage = true;

    this.scheduleAcceptTimer(500, () => {
      if (this.componentDestroyed) {
        this.acceptProcessing = false;
        return;
      }
      try {
        this.showThankYouDialog = true;
        this.scheduleAcceptTimer(2000, () => {
          if (this.componentDestroyed) {
            this.acceptProcessing = false;
            return;
          }
          try {
            this.showThankYouDialog = false;
            this.paymentPage = false;
            const signature = this.savedSignatureDataUrl
              ? this.savedSignatureDataUrl
              : this.userName.value
                ? this.generateSignatureImage(this.userName.value)
                : '';
            if (this.componentDestroyed) {
              return;
            }
            if (this.hasTemplateTerms) {
              this.dialogRef.close({
                signature,
                termsChecked: { ...this.termsChecked },
              });
            } else {
              this.dialogRef.close(signature);
            }
          } finally {
            this.acceptProcessing = false;
          }
        });
      } catch (error) {
        this.acceptProcessing = false;
      }
    });
  }

  /** Schedule a one-shot timer tracked for ngOnDestroy cleanup. */
  private scheduleAcceptTimer(delayMs: number, fn: () => void): void {
    const timerId = setTimeout(() => {
      this.clearAcceptTimer(timerId);
      if (this.componentDestroyed) {
        this.acceptProcessing = false;
        return;
      }
      try {
        fn();
      } catch (error) {
        this.acceptProcessing = false;
      }
    }, delayMs);
    this.acceptTimerIds.push(timerId);
  }

  private clearAcceptTimer(timerId: ReturnType<typeof setTimeout>): void {
    const idx = this.acceptTimerIds.indexOf(timerId);
    if (idx > -1) {
      this.acceptTimerIds.splice(idx, 1);
    }
  }

  ngOnDestroy(): void {
    this._destroyed = true;
    this.componentDestroyed = true;
    this.acceptTimerIds.forEach((id) => clearTimeout(id));
    this.acceptTimerIds = [];
    this.acceptProcessing = false;
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
  

  

  createForm() {
    this.debitCardForm = this.fb.group({
      cardNumber: ['', [Validators.required, Validators.pattern(/^\d{16}$/)]],
      expiryDate: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])\/\d{2}$/)]],
      cvc: ['', [Validators.required, Validators.pattern(/^\d{3}$/)]],
      name:['', Validators.required]
    });
  }

  get cardNumber() {
    return this.debitCardForm.get('cardNumber');
  }

  formatCardNumber(event: any) {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    input = input.substring(0, 16); // Limit to 16 characters

    // Add a space after every 4 numbers
    input = input.replace(/(\d{4})/g, '$1 ');

    // Update the form control value
    this.cardNumber.setValue(input);
}

  get name(){
   return this.debitCardForm.get('name')
  }
  get transferType(){
    return this.transferForm.get('transferType')
   }
   get accountNumber(){
    return this.transferForm.get('accountNumber')
   }
   get bankName(){
    return this.transferForm.get('bankName')
   }
   get email(){
    return this.transferForm.get('email')
   }
   get beneficiary(){
    return this.transferForm.get('beneficiary')
   }
 
  get expiryDate() {
    return this.debitCardForm.get('expiryDate');
  }

  get cvc() {
    return this.debitCardForm.get('cvc');
  }

  paymentMehtod(type){
    this.paymentMethod = type;
    // Each method button pays its own due-now amount — reflect it in the displayed/charged amount.
    this.dailogData.data = this.amountForMethod(type);
    if (this.paymentMethod === 'credit') {
      // The #card-number host renders with the credit form; create+mount (or re-mount, since the
      // *ngIf detaches the Stripe elements when another method is selected) the card fields.
      setTimeout(() => {
        if (this._stripeInitialized && this.card) {
          try {
            this.card.mount('#card-number');
            this.cardExpiry.mount('#card-expiry');
            this.cardCvc.mount('#card-cvc');
          } catch (e) { /* elements already mounted */ }
        } else {
          this.initializeStripe();
        }
      }, 200);
    }
  }


 
  formatTimestamp(isoTimestamp: string): any {
    // Parse ISO timestamp
    if(isoTimestamp){
      const date = new Date(isoTimestamp);
  
      // Create the custom format
      const formattedDate = this.datePipe.transform(date, 'EEE d MMM, y');
    
      return formattedDate;
  
    }
  }

  onPriceSelectionChange() {
    // this.tableDataItems()
    // You can perform any additional logic here based on the selected value
  }

  getSelectedImage(images: any[]): any | null {
    if (!images || images.length === 0) return null;

    // Create a sorted copy of images
    const sortedImages = images.slice().sort((a, b) => {
        const hasImagesOrder = images.some(image => image.images_order !== 0);

        if (true) {
            // Sort by created_at (oldest first)
            const dateDifference = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            if (dateDifference !== 0) {
                return dateDifference;
            }

            // Fallback to sorting by id if created_at is identical
            return (a.id || 0) - (b.id || 0);
        }

        // Sorting logic when images_order is present
        if (a.images_order === null && b.images_order === null) return 0;
        if (a.images_order === null) return 1;
        if (b.images_order === null) return -1;
        if (a.images_order === 1) return -1;
        if (b.images_order === 1) return 1;

        return (a.images_order || 0) - (b.images_order || 0);
    });

    // Return the first image from the sorted array
    return sortedImages.length > 0 ? sortedImages[0] : null;
}
  parsePrice(priceString: string | null): string {
    try {
      const priceObject = JSON.parse(priceString || '');
      return priceObject?.pricesA || ''; // Adjust the property name accordingly
    } catch (error) {
      console.error('Error parsing price:', error);
      return '';
    }
  }

  getImage(element){
    
  }

  async getCurrency() {
    const currencySubs = await this.businessProfileService.currency().subscribe((val: any) => {
      // Assuming that val.data is an array of currencies
      this.currencyArr = val.data;
      // console.log(this.crSymbol ,'this.currencyArr')
      const matchingCurrency = val.data.find(
        currency =>
          currency.currency_symbol === this.crSymbol 
      );
      // console.log(matchingCurrency,'matchingCurrencymatchingCurrency')

      this.selectedCurrency = { currency_code: matchingCurrency.currency_code, currency_symbol:matchingCurrency.currency_symbol };    
      // Check if currencyArr is empty or not
      if (this.currencyArr.length > 0) {
        this.selectedCurrency = this.currencyArr.find(x=>x.currency_code ==this.selectedCurrency?.currency_code );
        this.showCurrencySymbol=this.selectedCurrency
        this.showCurrencySymbolExchange=this.selectedCurrency

      } else {
      }
  
    });

    // const matchingCurrency = this.currencyArr.find(
    //   currency =>
    //     currency.currency_symbol === this.crSymbol
    // );  tu
    // this.selectedCurrency = matchingCurrency;

  }

  

  

  editContactInfo() {
    this._router.navigate(['/dash/contacts/edit/'+ this.contactId, { 'moduleTypeQuote': 'quoteListing',quote_id:this.update_id }]);

    // this._router.navigate(['/dash/contacts/edit/' + this.contactId]);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
  closeDialogThankYou() {
    console.log(this.userName.value,'this.userName.value',this.savedSignatureDataUrl,'this.savedSignatureDataUrl')
    const signature = this.savedSignatureDataUrl ? this.savedSignatureDataUrl : (this.userName.value ? this.generateSignatureImage(this.userName.value) : '');
    this.dialogRef.close(signature);
  }

  generateSignatureImage(text: string): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    canvas.width = 500;
    canvas.height = 100;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // Use the same font as specified in the HTML template for the input field
    ctx.font = "italic 48px 'Shadows Into Light', cursive";
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillText(text, canvas.width / 2, canvas.height / 2);

    return canvas.toDataURL('image/png');
  }

  getFilteredColumns(columns: any[], orientation: string): any[] {
    const filteredColumns = columns.filter(
      (column) => column.orientation === orientation
    );
    this.columnsToDisplay = filteredColumns.map((c) => c.name);
    return filteredColumns;
  }

  checkAddress(address: any): boolean {
    const houseNumber = address ? address.house_number : '';
    const streetName = address ? address.street_name : '';
    const postalCode = address ? address.postal_code : '';
    const country = address?.country ? address.country.name : '';
    const interiorNumber = address ? address.interior_number : '';
    const state = address.state ? address.state.name : '';
    const city = address.city_name ? address.city_name : '';

    return houseNumber || streetName || postalCode || country || interiorNumber || state || city;
  }

  getAddress(address: any): string {
    return formatDisplayAddress(address);
  }

  

  onExpandedChange(expandedMessage: boolean): void {
    this.widgetsPanel = expandedMessage;
  }
  onPriceExpandedChange(expandedMessage: boolean): void {
    this.pricePanel = expandedMessage;
  }

  infoDropdown() {
    this.inforDropdown = !this.inforDropdown;
  }


  getTableDataSource(tableIndex: number): MatTableDataSource<any> {
    return new MatTableDataSource<any>(this.tables[tableIndex].data);
  }

  private calculateResult() {
    this.totalValue = this.lengthValue * this.widthValue;
  }

  addTotals(name,id,kk) {
    let totalDiscount = 0;
    let totalTaxPrice = 0;
    let grandTotal = 0;
    let Total=0;
          this.afterDiscount=0;
      this.aftertax=0;
      this.totalCost=0;
      this.profitmargin=0;
      this.salesCommission=0;

    if (this.addedItemsData.length > 1) {
      // let totalDiscount = 0;
      // let totalTaxPrice = 0;
      // let grandTotal = 0;
      // let Total=0;
      // afterDiscount:any;
      // aftertax:any;
      // totalCost:any;
      // profitmargin:any;
      // salesCommission:any;
    

      this.addedItemsData.forEach(item => {
          totalDiscount += item.total_discount;
          totalTaxPrice += item.tax_price;
          grandTotal += item.Total;
          this.afterDiscount +=item?.priceAfterDiscount;
          this.aftertax +=item?.priceAftertax;
          this.totalCost += item?.totalCostAll;
          this.profitmargin +=Number(item?.profitMargin);
          this.salesCommission+=item?.commissionSales;

      });
  
       Total = (grandTotal - totalDiscount) + totalTaxPrice;
  }
  else{
    totalDiscount +=(parseFloat(this.addedItemsData[0]?.total_discount));
    totalTaxPrice +=(parseFloat(this.addedItemsData[0]?.tax_price));
    grandTotal +=(parseFloat(this.addedItemsData[0]?.Total));
    Total=(grandTotal - totalDiscount)+ totalTaxPrice;
    this.afterDiscount +=this.addedItemsData[0]?.priceAfterDiscount;
    this.aftertax +=this.addedItemsData[0]?.priceAftertax;
    this.totalCost += this.addedItemsData[0]?.totalCostAll;
    this.profitmargin +=Number(this.addedItemsData[0]?.profitMargin);
    this.salesCommission+=this.addedItemsData[0]?.commissionSales;


  }
  this.profitmargin=this.profitmargin/this.addedItemsData?.length

  this.totalCost=this.totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  this.aftertax=this.aftertax.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  this.salesCommission=this.salesCommission.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  this.afterDiscount=this.afterDiscount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  this.profitmargin=this.profitmargin.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  this.totalCost1=this.totalCost
  this.aftertax1=this.aftertax
  this.salesCommission1=this.salesCommission
  this.afterDiscount1=this.afterDiscount
  this.profitmargin1=this.profitmargin




  let totalDiscountNew=totalDiscount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  let totalTaxPriceNew=totalTaxPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  let grandTotalNew=grandTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  let TotalNew=Total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  this.actpageIndx = kk;
  let totalObject=this.dropListData[this.actpageIndx].items.find(x=>x.name =='Total')

    const index = this.dropListData[this.actpageIndx].items.findIndex(
      (item: any) => item?.name === totalObject.name && item?.id === totalObject.id
    );
    if (index !== -1) {
      this.dropListData[this.actpageIndx].items[index].subTotalAmount =grandTotalNew
      this.dropListData[this.actpageIndx].items[index].discountAmount =totalDiscountNew
      this.dropListData[this.actpageIndx].items[index].taxAmount =totalTaxPriceNew
      this.dropListData[this.actpageIndx].items[index].totalAmount =TotalNew



    }
   
    this.cdr.detectChanges();
            
}


  
  
  async matchKeys(firstArray, secondObject) {
    const matchedArray = [];
    if (secondObject && secondObject.data) {
        firstArray.forEach(obj => {
            Object.keys(secondObject.data).forEach(key => {
                if (obj.key === key) {
                    matchedArray.push({ [obj.name]: secondObject.data[key] });
                }
            });
        });
    }
    return matchedArray;
  }
  

  logTableData(name, id,type) {    
    // Clear existing rowData
    this.tableData = [];
    const index = this.dropListData[this.actpageIndx].items.findIndex(
      (item: any) => item?.name === name && item?.id === id
    );
  
    if (index !== -1) {
      const displayedColumns = this.dropListData[this.actpageIndx].items[index]?.tableDisplayedColumns;
  if(type =='rows'){
      // Iterate through each row and push the data to tableData array
      for (const row of this.dropListData[this.actpageIndx].items[index]?.tableDisplayedRows) {
        const rowDataItem: any = {};
        for (const column of displayedColumns) {
          rowDataItem[column.name] = row[column.name];
        }
        this.tableData.push(rowDataItem);
        this.dropListData[this.actpageIndx].items[index].tableDisplayedRows =this.tableData;

      }

  }
    }
  }
  initializeHeaderData() {
    for (let j = 0; j < this.selectedColumnCount; j++) {
      this.headerData.push(`Column ${j + 1}`);
    }
  }





 
  rawSelectedDate
  onDateChange(newDate: Date | string,name,id,kk,title) {
    this.selectedDate = newDate;
    this.formatSelectedDate(name,id,kk); // Call the formatting function
    console.log('Selected Date:', newDate);
    // You can perform additional actions with the selected date here
  }

  formatSelectedDate(name,id,kk) {
    this.actpageIndx=kk
    const index = this.dropListData[this.actpageIndx].items.findIndex(
      (item: any) => item?.name === name && item?.id === id
    );
   
    // Use the DatePipe to format the selected date
    if (this.selectedDate) {
      this.formattedSelectedDate = this.datePipe.transform(
        this.selectedDate,
        'EEE d MMM, y'
      );
    }
    if (index !== -1) {
      this.dropListData[this.actpageIndx].items[index].itemDate =
      this.formattedSelectedDate;
    }
  }
  @ViewChild('picker') picker: MatDatepicker<Date>;

  // formattedSelectedDate: string; // You should initialize this with your date value

  openDatePicker() {
    this.picker.open(); // Open the date picker
  }

  getCurrentFormattedDate(name,id,kk) {
    this.actpageIndx=kk
    const index = this.dropListData[this.actpageIndx].items.findIndex(
      (item: any) => item?.name === name && item?.id === id
    );
    const currentDate = new Date();
    const options: Intl.DateTimeFormatOptions = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(currentDate);
    if (index !== -1) {
      this.dropListData[this.actpageIndx].items[index].quoteCreationDate =
      formattedDate;
      this.formattedSelectedDate = formattedDate
      this.creationDate=true
      return formattedDate;
    }else return "";
  }

  commonFormat(dateString: string): string {
    if (!dateString) {
      return '';
    }
    const currentDate = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(currentDate);
    
    return formattedDate;


}



handleSignatureSaved(signatureDataUrl: string | null) {
  this.savedSignatureDataUrl=signatureDataUrl
  // this.isSignatureEmpty = false;
  this.isSignatureEmpty = !signatureDataUrl;
  }

 

  initializeStripe() {
    if (this._stripeInitialized) return;
    if (!document.getElementById('card-number')) return;

    // The Stripe SDK (loaded via the <script> in index.html) may not be ready yet when this
    // fires — on a slow network, or if the request was blocked. Wait for the global and retry
    // instead of throwing "Stripe is not defined", which left the card form blank. Don't set
    // _stripeInitialized here so the retry can proceed.
    if (typeof Stripe === 'undefined') {
      this.ensureStripeSdk()
        .then(() => this.initializeStripe())
        .catch(() => {
          this.infoMsg = 'Unable to load the payment form. Please refresh and try again.';
          this.cdr.detectChanges();
        });
      return;
    }

    this._stripeInitialized = true; // Set early to avoid race conditions from multiple calls

    if (this.stripeDataKeys?.keysConnections?.length) {
      this.buttonDisabled = true;
      try {
        if (!this.stripe) {
            this.stripe = Stripe(this.stripeDataKeys.keysConnections[0].publicKey);
        }
        this.elements = this.stripe.elements();

        const isMobile = this.dailogData?.isMobileView;
        const style = {
          base: {
            color: '#32325d',
            lineHeight: isMobile ? '48px' : '18px',
            fontFamily: 'Poppins, "Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: isMobile ? '40px' : '16px',
            '::placeholder': {
              color: '#aab7c4',
              fontSize: isMobile ? '28px' : '16px',
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        };

        this.card = this.elements.create('cardNumber', { style });
        this.cardExpiry = this.elements.create('cardExpiry', { style });
        this.cardCvc = this.elements.create('cardCvc', { style });

        this.card.mount('#card-number');
        this.cardExpiry.mount('#card-expiry');
        this.cardCvc.mount('#card-cvc');

        this.card.on('change', (event) => this.handleCardChange(event, 'card'));
        this.cardExpiry.on('change', (event) => this.handleCardChange(event, 'expiry'));
        this.cardCvc.on('change', (event) => this.handleCardChange(event, 'cvc'));

        this._stripeInitialized = true;
      } catch (e) {
        console.error('Stripe initialization failed', e);
        this._stripeInitialized = false;
      }
    } else if (this.stripeDataKeys && this.stripeDataKeys.connection !== 'Connected') {
      this.infoMsg = 'Stripe is not connected, please contact the merchant';
      this.buttonDisabled = true;
    }
  }

  // Ensures the Stripe.js SDK global is available. It's normally loaded by the <script> in
  // index.html, but that can still be in flight (or blocked) when the payment dialog opens.
  // Resolves once `Stripe` exists; rejects if the script fails to load. Cached so concurrent
  // callers share one load.
  private ensureStripeSdk(): Promise<void> {
    if (typeof Stripe !== 'undefined') return Promise.resolve();
    if (this.stripeSdkPromise) return this.stripeSdkPromise;
    this.stripeSdkPromise = new Promise<void>((resolve, reject) => {
      const settle = () =>
        typeof Stripe !== 'undefined' ? resolve() : reject(new Error('Stripe SDK missing after load'));
      const existing = document.querySelector('script[src^="https://js.stripe.com/v3"]') as HTMLScriptElement | null;
      if (existing) {
        // index.html's script is still loading — resolve when it finishes.
        existing.addEventListener('load', settle);
        existing.addEventListener('error', () => reject(new Error('Stripe SDK failed to load')));
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      script.onload = settle;
      script.onerror = () => reject(new Error('Stripe SDK failed to load'));
      document.head.appendChild(script);
    });
    return this.stripeSdkPromise;
  }




ngAfterViewInit(): void {
  if (this.stripeDataKeys) {
    if (this.stripeDataKeys.connection === 'Connected') {
      this.buttonDisabled = true;
      if (this.stripeDataKeys.keysConnections?.length) {
        setTimeout(() => {
          this.initializeStripe(); // Delay to allow DOM rendering
        }, 100);
      }
    } else {
      this.infoMsg = 'Stripe is not connected, please contact the merchant';
      this.buttonDisabled = true;
    }
  }

  // Other unrelated logic can stay
  if (this.showCanvas && this.signaturePadCanvas) {
    this.signaturePad = new SignaturePad(this.signaturePadCanvas.nativeElement);
  }

  const paginationButton = this.tabGroup?._elementRef?.nativeElement?.querySelector('.mat-tab-header-pagination-after');
  const paginationbeforeButton = this.tabGroup?._elementRef?.nativeElement?.querySelector('.mat-tab-header-pagination-before');

  if (paginationButton) {
    this.renderer.listen(paginationButton, 'click', () => {
      if (window.innerWidth <= 425) {
        this.selectedTabIndex++;
        this.tabChanged(this.selectedTabIndex);
      }
    });
  } else if (paginationbeforeButton) {
    this.renderer.listen(paginationbeforeButton, 'click', () => {
      if (window.innerWidth <= 425) {
        this.selectedTabIndex--;
        this.tabChanged(this.selectedTabIndex);
      }
    });
  }
}


sourceOfContact(){
  const formContactListSubs = this.editContactService
  .formContactList()
  .subscribe((val: any) => {
    this.formContactList = val.data;
    
  });
this.subscriptions.push(formContactListSubs);

}


getEmailsAsString(): string {
  return this.merchantContactData?.merchant_customer_emails.map(customer => customer.email).join(', ');
}

onCurrencySelectionChange(event){
this.showCurrencySymbol=event.value
}

onCurrencySelectionChange2(event){
  this.showCurrencySymbolExchange=event.value
  this.afterDiscount1 =this.afterDiscount ;
  this.aftertax1 = this.aftertax;
  this.totalCost1 = this.totalCost;
  this.salesCommission1 = this.salesCommission;

  
}

onRateChange(value: string) {
  if (this.showCurrencySymbolExchange?.currency_symbol == this.selectedCurrency.currency_symbol) {
    // Handle case where currencies are the same, if needed
  } else {
    this.rateValue = Number(value);
    if(this.rateValue ==0){
      this.showCurrencySymbolExchange=this.showCurrencySymbol
      this.afterDiscount1 =this.afterDiscount ;
      this.aftertax1 = this.aftertax;
      this.totalCost1 = this.totalCost;
      this.salesCommission1 = this.salesCommission;
  
    }else{
      let afterDiscountNumber = parseFloat(this.afterDiscount.replace(/,/g, ''));
      let aftertaxNumber = parseFloat(this.aftertax.replace(/,/g, ''));
      let totalCostNumber = parseFloat(this.totalCost.replace(/,/g, ''));
      let salesCommissionNumber = parseFloat(this.salesCommission.replace(/,/g, ''));
  
      this.afterDiscount1 = afterDiscountNumber * this.rateValue;
      this.aftertax1 = aftertaxNumber * this.rateValue;
      this.totalCost1 = totalCostNumber * this.rateValue;
      this.salesCommission1 = salesCommissionNumber * this.rateValue;
  
      this.totalCost1=this.totalCost1.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      this.aftertax1=this.aftertax1.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      this.salesCommission1=this.salesCommission1.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      this.afterDiscount1=this.afterDiscount1.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      this.profitmargin1=this.profitmargin.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  
    }
  }
}
  submited:boolean=false;
  get dStageValid():any {
    if(this.addQuoteStageForm?.controls)
    return this.addQuoteStageForm.controls;
  else return null
  }

  changeColor(event) {
    // this.leadDealModel.color = event?.target?.value;
    this.addQuoteStageForm?.controls['color'].setValue(event?.target?.value);
  }

  changeColor1(event) {
    // this.leadDealModel.color = event?.target?.value ? ('#' + event?.target?.value.replace(/#/g, "")) : null;
    this.addQuoteStageForm?.controls['color'].setValue(event?.target?.value ? ('#' + event?.target?.value.replace(/#/g, "")) : null);
  }

  saveQuoteStage(){
    if(!this.addQuoteStageForm?.valid){
       this.addQuoteStageForm.markAllAsTouched(); 
       return;
    }
    if(this.dailogData?.data?.id){
      this.addQuoteStageForm.value.id=this.dailogData?.data?.id;
      this.QuoteTemplateServices.update_Quote_Stage(this.addQuoteStageForm?.value).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (resp) => {
      }
    })
    }
    this.dialogRef.close(this.addQuoteStageForm?.value);
  }

  changeImage(eventType: string) {
    if (eventType === 'mouseover') {
      this.chequeImage = this.otherImage;
    } else if (eventType === 'mouseout') {
      this.chequeImage = '../../../assets/icons/cheque_black.png';
    }
  }
  removeQuoteStage(stage){
    let itemDeletedata = {
      title: `Are you sure you want to delete`,
      delItems: true,
    };
    let payload=[{
      Id:stage?.id
    }]
    const dialogRef = this.dialog.open(MatConfirmDeleteComponent, {
      width: '350px',
      data: itemDeletedata,
    });
    dialogRef.afterClosed().subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.QuoteTemplateServices.delete_Quote_Stage(payload).subscribe({
            next:(resp)=>{
              this.dialogRef.close('delete');
            },
            error:(err)=>{
              console.log("got error : ",err);
            }
          })
        }
      },
    );
  }

  updateTaxIndex(data,i){
   
    if (this.addItemPriceTaxArr.length > 0) {
     let found = false;
     this.addItemPriceTaxArr.forEach(item => {
         if (item.taxData.customValueId === data.taxData.customValueId) {
             found = true;
         }
     });
 
     if (!found) {
         this.addItemPriceTaxArr.push(data);
     }
     }else{
       console.log('llllll');
       
      this.addItemPriceTaxArr.push(data)
     }
       
     
     
   }
   clearValue(){
     this.addItemPriceTaxArr = []
   }

   addPrice(event: Event) {
    event.stopPropagation();
    // console.log(this.dailogData, 'Dialog Data');
  
    // Parse minPrice from dialog data
    const minPrice = parseFloat(this.dailogData?.minPrice);
    const numericValue = parseFloat(this.newPrice.value);
  
    // Check if the new price is less than the minimum price
    if (!isNaN(minPrice) && numericValue < minPrice) {
      this.snackbar.open(`Price must be greater than or equal to minimum price (Minimum Price is ${minPrice}).`, 'Close', {
        duration: 3000, // 3 seconds
        horizontalPosition: 'center',
      });
      return; // Exit the function to prevent adding the price
    }
  
    const formattedValue = this.decimalPipe.transform(numericValue, '1.2-2');
  
    // Check if the formatted value already exists in pricesArrayNew
    const priceExists = this.pricesArrayNew.some(item => item.price === formattedValue);
  
    if (!priceExists) {
      // Push the new price into the pricesArray if it doesn't exist
      this.pricesArrayNew.push({ price: formattedValue, priceName: '' });
  
      this.selectedPriceA = formattedValue;
      this.newPriceA = formattedValue;
      this.calculateProfit(formattedValue);
  
      this.addPrices = true;
    } else {
      console.log('This price already exists in the array.');
    }
    
  
    // Reset the newPrice form control
    this.newPrice.reset();
    this.select.close();
  }
  
  
  
  

   updateIndex(data, i) {
    this.newDiscount=data
  }

  updatePrice(value: {price:string,priceName:string}) {
    this.newPriceA=value.price
    this.calculateProfit(value?.price)
  }

  calculateProfit(price) {
    const fix_cost_per_unit = parseFloat(this.fixCostUnit|| 0) || 0;
    let priceAString = typeof price === 'number' ? String(price) : price; // Get the price as a string
    if (typeof priceAString === 'string') {
        const priceA = parseFloat(priceAString.replace(/,/g, '')) || 0; // Remove commas and parse as a float

        // Apply discount to the priceA
        const discountVal = this.newDiscount?.discounts || this.itemAddModel?.item_prices?.[0]?.discount || 0;
        const discountPercent = parseFloat(String(discountVal).replace('%', '')) || 0;
        const priceAfterDiscount = priceA - (priceA * discountPercent / 100);

        if (priceAfterDiscount > 0) {
            let profit = priceAfterDiscount - fix_cost_per_unit;
            let profitMargin = ((profit * 100) / priceAfterDiscount).toFixed(2);

            const sales_commission = parseFloat(this.sales_commission) || 0;
            const sales_commission_type = this.sales_comm_type; // Assuming sales_commission_type is defined somewhere
            if (sales_commission !== 0 && (sales_commission_type === 2 || sales_commission_type === 1)) {
              if (sales_commission_type === 2) {
                  profit -= (profit * sales_commission / 100);  // Subtract as a percentage
              } else {
                  profit -= sales_commission;  // Subtract as a direct value
              }
              profitMargin = ((profit * 100) / priceAfterDiscount).toFixed(2);
            }
          

            this.profit = profit;
            this.profitMargn = profitMargin;
        } else {
            this.profitMargn = 100;
            this.profit = 100;
        }
    } else {
        this.profitMargn = 100;
        this.profit = 100;
    }
}


  increase(value,type){
   console.log(value);
   
    if(type == 'length'){
      this.lenghtValue = value
      this.lenghtValue++
    } else if(type == 'quantity'){
      // Use initialQuantity for increment, same as desktop version
      const newQuantity = (this.currentQuantity || 1) + (this.initialQuantity || 1);
      this.currentQuantity = newQuantity;
      this.dailogData.QuantityChange = this.currentQuantity.toString();
      this.calculateProfit(this.newPriceA);
    } else {
      this.width_Value = value
      this.width_Value++
    }
  }

  decrease(value,type){
    if(type == 'length'){
      
      this.lenghtValue = value
      if(this.lenghtValue>0){
        
        this.lenghtValue--
        
      }
     
    } else if(type == 'quantity'){
      // Use initialQuantity for decrement, same as desktop version
      let newQuantity = (this.currentQuantity || 1) - (this.initialQuantity || 1);
      if(newQuantity <= 0){
        newQuantity = 1;
      }
      this.currentQuantity = newQuantity;
      this.dailogData.QuantityChange = this.currentQuantity.toString();
      this.calculateProfit(this.newPriceA);
    } else {
      this.width_Value = value
      if(this.width_Value>0){
        this.width_Value--
      }
    }
  }

  // The quantity field is freely editable (the user can clear it and type a new value
  // like 4). We only coerce an empty/invalid value back to a valid one when they leave
  // the field, then sync it onto the item and recalculate.
  normalizeQuantity() {
    let q = parseInt(String(this.currentQuantity), 10);
    if (isNaN(q) || q <= 0) {
      q = 1;
    }
    this.currentQuantity = q;
    if (this.dailogData) {
      this.dailogData.QuantityChange = q.toString();
    }
    this.calculateProfit(this.newPriceA);
  }

  async updateItem() {

    if (this.newDiscount) {
        const discountValue = typeof this.newDiscount?.discounts === 'string' ? parseFloat(this.newDiscount?.discounts) : this.newDiscount?.discounts;
        if (!isNaN(discountValue)) {
            this.itemAddModel.item_prices[0].discount = discountValue.toString(); // Update discount
        }
    }

    // Check if newPriceA is provided and convert it to a number if it's a string
    if (this.newPriceA) {
        const priceAValue = this.newPriceA;
            // Parse the price string into an object
            const priceObject = JSON.parse(this.itemAddModel.item_prices[0].price);

            // Update pricesA property in the priceObject
            priceObject.pricesA = priceAValue;

            // Update the price property with the updated priceObject
            this.itemAddModel.item_prices[0].price = JSON.stringify(priceObject);
        
    }
    
    // Update quantity in itemAddModel and dialogData
    if (this.currentQuantity) {
        this.itemAddModel.unit_quantity = this.currentQuantity.toString();
        this.dailogData.QuantityChange = this.currentQuantity.toString();
    }
    
    // Update description from element if it exists
    if (this.dailogData?.element) {
        const descriptionKey = this.getDescriptionColumnName();
        const descriptionValue = this.dailogData.element[descriptionKey];
        if (descriptionValue !== undefined) {
            // Update itemAddModel with the description from element
            if (descriptionKey === 'description') {
                this.itemAddModel.description = descriptionValue;
            } else if (descriptionKey === 'description_es') {
                this.itemAddModel.description_es = descriptionValue;
            } else if (descriptionKey === 'description_fr') {
                this.itemAddModel.description_fr = descriptionValue;
            }
        }
    }
    
    this.itemsListArr={data:[this.itemAddModel]}
    if (this._destroyed || this.componentDestroyed) {
      return;
    }
    if (await this.tableDataItems([])) {
      this.closeQuoteDialog(this.itemsListArr);
    }
}



  async editItemList(id) {
    
    const editItemListSubs = this.itemsService.iteamDataList(id).subscribe(async res => {
      console.log(res?.data,'mmmmmmmmmmmmmmmmmmxxxxxxxxxxxxxxxx');
      
      if (this.dailogData?.type === 'quote' && this.dailogData?.element) {
        if (this.dailogData.element.totalCost !== undefined && res.data?.item_prices?.length > 0) {
          res.data.item_prices[0].fix_cost_per_unit = this.dailogData.element.totalCost;
        }
      }
      
      if (!res?.data?.item_prices?.length) {
        if (!res?.data) res = { data: {} };
        res.data.item_prices = [{ price: '{}', discount: null }];
      }
      this.itemAddModel = res.data; 
      this.itemCategoryId=res.data?.categoryId
      this.newItemData=res.data
      this.itemNewId=res.data?.id
      this.fixCostUnit=res.data?.item_prices[0]?.fix_cost_per_unit
     this.sales_commission = Number(res.data?.item_prices[0]?.sales_commission || 0)
  .toFixed(2);

      this.sales_comm_type=res.data?.item_prices[0]?.sales_comm_type

//       console.log(this.itemAddModel,'llllllll');
           
//       this.isDeactivated=true
//       this.editItemsImages = this.itemAddModel?.item_images.sort((a, b) => {
//         if (a.images_order === null && b.images_order === null) {
//             return 0; // No change in order
//         }
//         if (a.images_order === null) {
//             return 1; // Put images with null order after others
//         }
//         if (b.images_order === null) {
//             return -1; // Put images with null order before others
//         }
//         // Both images have a defined images_order
//         if (a.images_order === 1) {
//             return -1; // Put images with images_order 1 at the top
//         }
//         if (b.images_order === 1) {
//             return 1; // Put images with images_order 1 at the top
//         }
//         return a.images_order - b.images_order; // Sort by images_order
//     });
//     const userImageData=this.editItemsImages[0]
  
//       let selectedCat=this.cateogryListArr.find(item=>item.id==this.inputData.categoryId);

//       if(this.inputData.categoryId){
//         this.getCatId(this.inputData.categoryId)
//         await this.subCategory()
//       }
      
//       let selectedSubCat  = this.subCategoryListArr.find(item=> {return item.id == this.itemAddModel.subcategory_id});

//       this.unitSelect.patchValue(this.itemAddModel?.unit)
//       this.itemType.patchValue(this.itemAddModel?.item_coming_from)
//       this.userBasicInfoForm.patchValue({
//         categoryId:selectedCat?.name,
//         subCategoryId:selectedSubCat?.name

//       })
      
//       this.addEditItemCodeArr = this.itemAddModel.childitems;

//       const bundles = this.itemAddModel.bundles;
//       let bundlesListData;
//       for (let i = 0; i < bundles?.length; ++i) {
//         bundlesListData = { 'item_bundles': { 'bundleId': bundles[i]['id'], 'title': bundles[i]['title'], 'hide_price': bundles[i]['item_bundles']['hide_price'] } }
//         this.selectedBundle.push(bundlesListData);
//       }
//       this.itemAdditionalDetailsArr = this.itemAddModel.item_additional_details
//       const warehouses = this.itemAddModel.warehouses;
//       let warehousesListData;
//       for (let i = 0; i < warehouses?.length; ++i) {
//         this.addWarehouseArr.push({status:1, 'warehouseId': warehouses[i]['id'] ,'name': warehouses[i]['name'],'items': warehouses[i]['item_warehouses']['items'] });
//       }
//       // ===================== Item_price_discounts  ===========================
let discountValue: any = ''
      if(this.itemAddModel?.item_prices?.[0]?.discount != null){
         discountValue = String(this.itemAddModel.item_prices[0].discount).split(',');
      }      let discountValueArr = [];
      for (let i = 0; i < discountValue.length; ++i) {
      if (discountValue[i] !== '') { 
      discountValueArr.push({ 'discounts': parseInt(discountValue[i], 10) });
    }
    }

      this.addDiscountsArr = discountValueArr;
      this.addDiscountsArr.sort((a, b) => a.discounts - b.discounts);
      if(this.addDiscountsArr?.length){
        this.showUnselect=true
      }else{
        this.showUnselect=false

      }
      this.applyDiscount={discounts:this.dailogData?.applyDiscount}
      this.newDiscount=this.applyDiscount
      this.cd.detectChanges()


      // const itemPrices = JSON.parse(this.itemAddModel?.item_prices[0]['price']);
      // const sanitizedPrices = Object.keys(itemPrices).reduce((result, key) => {
      //   const formattedPrice = itemPrices[key].replace(',', ''); // Remove commas
      //   result[key] = formattedPrice;
      //   return result;
      // }, {});      
      // this.itemPriceForm.patchValue(sanitizedPrices);
      
//       this.numberField.get('numberValue').setValue(Number(this.itemAddModel.unit_quantity))
let addedNewOne = JSON.parse(this.itemAddModel?.item_prices?.[0]?.['price'] || '{}');
this.newItemPriceList = [{ ...addedNewOne, pricesE: this.dailogData?.newPriceAdded || '' }];
// Default the price dropdown to the contact's assigned position (pricesA..pricesD), falling back to
// pricesA when that position is empty — matches how the item was priced when added to the quote.
const posKey = this.dailogData?.pricePositionKey;
const positionPrice = (posKey && addedNewOne?.[posKey] != null && String(addedNewOne[posKey]).trim() !== '')
  ? addedNewOne[posKey]
  : addedNewOne?.pricesA;
this.selectedPriceA = this.dailogData?.newPriceAdded ? this.dailogData?.newPriceAdded : positionPrice;
this.newPriceA = this.selectedPriceA;
this.pricesArrayNew = [];

// Helper function to check if the price already exists in the array
const isDuplicatePrice = (price: string) => {
  return this.pricesArrayNew.some(item => item.price === price);
};

if (Array.isArray(this.newItemPriceList) && this.newItemPriceList.length > 0) {
  const itemPrices = this.newItemPriceList[0];

  // Helper to check valid price
  const isValidPrice = (price: any) => price !== undefined && price !== null && price !== '' && !isDuplicatePrice(price);

  if (isValidPrice(itemPrices.pricesA)) {
    this.pricesArrayNew.push({ price: itemPrices.pricesA, priceName: 'Price A' });
  }
  if (isValidPrice(itemPrices.pricesB)) {
    this.pricesArrayNew.push({ price: itemPrices.pricesB, priceName: 'Price B' });
  }
  if (isValidPrice(itemPrices.pricesC)) {
    this.pricesArrayNew.push({ price: itemPrices.pricesC, priceName: 'Price C' });
  }
  if (isValidPrice(itemPrices.pricesD)) {
    this.pricesArrayNew.push({ price: itemPrices.pricesD, priceName: 'Price D' });
  }
  if (isValidPrice(itemPrices.pricesE)) {
    this.pricesArrayNew.push({ price: itemPrices.pricesE, priceName: '' });
  }
}

      // Initialize quantity
      this.currentQuantity = parseInt(this.dailogData?.QuantityChange || this.itemAddModel?.unit_quantity || '1', 10);
      if (isNaN(this.currentQuantity) || this.currentQuantity <= 0) {
        this.currentQuantity = 1;
      }
      
      // The +/- step is the item's PACK SIZE (unit_quantity), not the current quantity.
      // Deriving the step from the current quantity meant that once it had been edited
      // (e.g. down to 1) the step got stuck at 1, so clicking + went 12 -> 13 instead of
      // 12 -> 24. Fall back to the dialog value / current quantity only if no pack size.
      const packSize = parseInt(this.itemAddModel?.unit_quantity, 10);
      this.initialQuantity = (!isNaN(packSize) && packSize > 0)
        ? packSize
        : (this.dailogData?.initialQuantity || this.currentQuantity);
      if (!this.initialQuantity || isNaN(this.initialQuantity) || this.initialQuantity <= 0) {
        this.initialQuantity = 1;
      }

      this.cd.detectChanges()
      this.calculateProfit(this.newPriceA)


        let itemsPrice = JSON.parse(this.itemAddModel?.item_prices?.[0]?.['price'] || '{}');
      if(itemsPrice){
        this.itemPriceList = itemsPrice
        
      }
      
    
//       this.itemAddModel.price = JSON.parse(this.itemAddModel?.item_prices[0]['price']);
//       this.comments = this.itemAddModel.comments
//       this.itemAddModel.min_price = this.itemAddModel?.item_prices[0]['min_price'];
//       this.itemAddModel.currency_id = this.itemAddModel?.item_prices[0]['currency_id'];
//       this.userBasicInfoForm.get('currency_id')?.patchValue(Number(this.itemAddModel?.item_prices[0]['currency_id']))
//       this.itemAddModel.advance_unit_cal = this.itemAddModel?.item_prices[0]['advance_unit_cal'];
//       this.itemAddModel.sales_commission = this.itemAddModel?.item_prices[0]['sales_commission'];
//       this.itemAddModel.sales_comm_type = this.itemAddModel?.item_prices[0]['sales_comm_type'];
//       this.itemAddModel.fix_cost_per_unit = this.itemAddModel?.item_prices[0]['fix_cost_per_unit'];
//       this.itemAddModel.categoryId = this.inputData.categoryId
//       // ===================== Item_price  ===========================

      const item_prices_tax = this.itemAddModel?.item_prices_taxs;
let itemPricesTaxListData;

if (item_prices_tax) {
  for (let i = 0; i < item_prices_tax.length; ++i) {
    if (
      item_prices_tax[i] &&
      item_prices_tax[i]['taxe_value'] &&
      item_prices_tax[i]['custom_value'] &&
      item_prices_tax[i]['custom_value']['name'] &&
      item_prices_tax[i]['customValueId']
    ) {
      itemPricesTaxListData = {
        'taxe_value': item_prices_tax[i]['taxe_value'],
        'taxData': {
          'name': item_prices_tax[i]['custom_value']['name'],
          'customValueId': item_prices_tax[i]['customValueId']
        }
      };
      this.addItemPriceTaxArr.push(itemPricesTaxListData);
    }
  }
}

this.allTaxesList = this.addItemPriceTaxArr

      this.addItemPriceTaxArr.sort((a,b) => a.taxe_value - b.taxe_value);

    });
    this.subscriptions.push(editItemListSubs);  
  }

  compareFn(option1, option2) {
    return option1 && option2 ? option1.discounts === option2.discounts : option1 === option2;
  }


  openDropdown(event: MouseEvent) {
    event.stopPropagation(); // Prevents the event from propagating to parent elements
    this.salesTaxSelect.nativeElement.click(); // Programmatically trigger the click event of the mat-select
  }


  /**
   * Maps itemsListArr.data to quote lines. Returns true only when itemsListArr now holds the mapped
   * array; the caller closes the dialog only then (never with the raw { data } shape). A failed
   * formula load maps WITHOUT formulas; a mapper error is logged and the user told.
   */
  async tableDataItems(data: any = []): Promise<boolean> {
    let formulaFields: any[] | undefined;
    try {
      await this.formulaRuntime.ensureLoaded();
    } catch (err) {
      this.logger.log('Formula fields failed to load', err?.message || 'load failed');
      formulaFields = [];
    }
    if (this._destroyed || this.componentDestroyed) {
      return false;
    }
    this.formulaRuntime.invalidateFieldSumsCache();
    const sourceRows = Array.isArray(this.itemsListArr?.data) ? this.itemsListArr.data.slice() : null;
    if (!sourceRows) {
      return false;
    }
    let tableData: any[];
    try {
    tableData = this.formulaRuntime.syncMapLines(sourceRows, (item) => {
      const selectedImage = this.getSelectedImage(item.item_images);
      
      // Extract values from the item object
      const fix_cost_per_unit = parseFloat(item.item_prices[0]?.fix_cost_per_unit) || 0;
      const priceAStringified = item.item_prices[0]?.price as any; // Assuming it's a JSON-stringified string
      const sales_commission = parseFloat(item.item_prices[0]?.sales_commission) || 0;
      const sales_commission_type = item.item_prices[0]?.sales_comm_type;
      const minPrice = parseFloat(item.item_prices[0]?.min_price) || 0;
      let profit = 0;
      let profitMargin = 0;
      if (typeof priceAStringified === 'string') {
        try {
          const priceAObj = JSON.parse(priceAStringified);
          this.itemPrices = JSON.parse(priceAStringified);
          const priceA = parseFloat(
            (typeof priceAObj.pricesA === 'string' ? priceAObj.pricesA.replace(/,/g, '') : priceAObj.pricesA) || 0
          );
          
          let discount = 0.00;
          if (item.item_prices[0]?.discount) {
            const discountValue = item.item_prices[0].discount;
            discount = parseFloat(discountValue) / 100 || 0.00;
          }
          const priceAfterDiscount = priceA - (priceA * discount);

          if (priceAfterDiscount > 0) {
            profit = priceAfterDiscount - fix_cost_per_unit;
            profitMargin = (profit * 100) / priceAfterDiscount;
   
            if (sales_commission !== 0 && (sales_commission_type === 2 || sales_commission_type === 1)) {
              if (sales_commission_type === 2) {
                profit -= profit * (sales_commission / 100); // Subtract as a percentage
              } else {
                profit -= sales_commission; // Subtract as a direct value
              }
              profitMargin = (profit * 100) / priceAfterDiscount;
            }
          } else {
            profitMargin = 100;
            profit = 100;
          }
        } catch (error) {
          console.error('Error parsing priceAStringified:', error);
        }
      } else {
        profitMargin = 100;
        profit = 100;
      }

      const priceAObj = JSON.parse(priceAStringified);
      const price = parseFloat(
        priceAObj?.pricesA && typeof priceAObj.pricesA === 'string'
          ? priceAObj.pricesA.replace(/,/g, '')
          : priceAObj?.pricesA || 0
      );
            let discount = 0.00;
      let discountApply = 0.00;
      if (item.item_prices[0]?.discount) {
        const discountValue = item.item_prices[0].discount; // Access item_prices[0].discount
        discount = parseFloat(discountValue) / 100 || 0.00; // Correctly replace commas
      }
      if(this.newDiscount?.discounts){
        const discountValue = this.newDiscount?.discounts; // Access item_prices[0].discount
        discountApply = parseFloat(discountValue) / 100 || 0.00; // Correctly replace commas
      }
      
      let item_prices_tax = data?.length ? data : item.item_prices_taxs;
      let totalTax = 0;
      item_prices_tax.forEach((taxItem) => {
        if (taxItem.taxe_value) {
          const taxValue = parseFloat(taxItem.taxe_value.replace('%', '')) / 100 || 0.0;
          totalTax += taxValue;
        }
      });
  
      let tax = 0.0;
      if (item.item_prices_taxs[0]?.taxe_value) {
        const taxValue = Array.isArray(item.item_prices_taxs[0].taxe_value)
          ? item.item_prices_taxs[0].taxe_value[0]
          : item.item_prices_taxs[0].taxe_value;
        tax = parseFloat(taxValue.replace('%', '')) / 100 || 0.0;
      }
  
      const discPrice = price - price * discount;
      // Use currentQuantity if available, otherwise fall back to QuantityChange or unit_quantity
      const quantity = this.currentQuantity || parseInt(this.dailogData?.QuantityChange?this.dailogData?.QuantityChange:item.unit_quantity =='0'?'1':item.unit_quantity, 10);
      const tax_price = (price * tax) * quantity;
      const total_discount = (price * discount) * quantity;
      const total_discount_apply = (price * discountApply) * quantity;
      const perItemTax = price * tax;
      const totalTaxItem = price * totalTax;
      const perItemDisc = price * discount;
      const totalPrice = price * quantity;
      const priceAfterDiscount = totalPrice - total_discount_apply;
      const priceAftertax = totalPrice + tax_price;
      const totalCost = fix_cost_per_unit * quantity;
      const commissionSales = quantity * sales_commission;
      const discountArray = item?.item_prices[0]?.discount;
      const firstDiscount = discountArray || 0;
      const discountPercentage = firstDiscount / 100;
      const unitQuantity = item?.unit_quantity || 0;
      const description = item?.description ? item.description.replace(/<\/?p>/g, '') : '';
      const description_es = item?.description_es ? item.description_es.replace(/<\/?p>/g, '') : '';
      const description_fr = item?.description_fr ? item.description_fr.replace(/<\/?p>/g, '') : '';
      const total = (this.parsePrice(priceAStringified) as any) * (unitQuantity as number);
  
      let finalImage = selectedImage ? this.imageUrl + selectedImage.image : this.staticLogo;
      if (this.dailogData?.element) {
        if (this.dailogData.element.Item_image && !this.dailogData.element.Item_image.endsWith('placeholder_logo.png')) {
          finalImage = this.dailogData.element.Item_image;
        } else if (this.dailogData.element.picture && !this.dailogData.element.picture.endsWith('placeholder_logo.png')) {
          finalImage = this.dailogData.element.picture;
        } else if (this.dailogData.element['Item image'] && !this.dailogData.element['Item image'].endsWith('placeholder_logo.png')) {
          finalImage = this.dailogData.element['Item image'];
        }
      }

      let result: any = {
        'Applicable taxes': item_prices_tax.map(tax => ({
          name: tax?.custom_values ? tax?.custom_values.name : tax?.custom_value?.name,
          value: tax?.taxe_value
        })).map(tax => `${tax.name} (${tax.value}%)`).join(','),
        Comments:item?.comments?.length? item?.comments?.map((comment) => ({
          id: comment?.id,
          title: comment?.title,
          item_comments: comment?.item_comments,
        })):[],
        Description: description,
        Description_es: description_es,
        Description_fr: description_fr,
        perItemTax: perItemTax,
        minPrice:minPrice,
        sales_commission:sales_commission,
        sales_commission_type:sales_commission_type,
        newAddedPrice: this.newPriceA,
        totalTaxItem: totalTaxItem,
        perItemDisc: perItemDisc,
        inventory: item?.track_inventory || 0,
        newPricesArray: this.pricesArrayNew,
        Discount: `${firstDiscount}%`,
        perItemPrice: price,
        Item_code: item?.code || '',
        applyDiscount: this.newDiscount?.discounts,
        Item_image: finalImage,
        'Item image': finalImage,
        id: item?.id,
        item_type:item?.item_coming_from !==null?item?.item_coming_from:'',
        Quantity: quantity || item?.unit_quantity || '',
        QUANTITY: quantity || item?.unit_quantity || '',
        quantity: quantity || item?.unit_quantity || '',
        unit_quantity: quantity || item?.unit_quantity || '',
        // The item's pack size ("Quantity per Click", read when the dialog opened): the line's +/-
        // step. Without it the quote fell back to the current quantity and + jumped 6 -> 12.
        initialQuantity: this.initialQuantity || undefined,
        Item_name: item?.name || '',
        Tax_exempt: item?.item_prices_taxs[0]?.name,
        'Video URL': item?.video_url,
        'Website URL': item?.website_url,
        description: description,
        description_es: description_es,
        description_fr: description_fr,
        item: {
          name: item?.name || '',
          description: description,
        },
        Price: this.parsePrice(priceAStringified),
        discount: `${firstDiscount}%`,
        Total: totalPrice || 0,
        discPrice: discPrice.toFixed(2),
        created_at: item.created_at || '',
        category: item?.category?.name,
        categoryId: item?.category?.id?item?.category?.id:item?.categoryId,
        subCategory: item?.subcategory?.name,
        subCategoryId: item?.subcategory?.id?item?.subcategory?.id:item?.subCategoryId || item?.subcategory_id,
        Unit: item?.unit || '',
        total_discount: total_discount || 0,
        tax_price: tax_price || 0,
        comments: item?.comments?.map((comment) => ({
          id: comment.id,
          title: comment.title,
          item_comments: comment.item_comments,
        })),
        itemsComing: [
          { itemPrice: this.itemPrices.pricesA, comingFrom: 'Mexico', items: '25', itemDiscount: '5%' },
          { itemPrice: this.itemPrices.pricesB, comingFrom: 'Canada', items: '15', itemDiscount: '8%' },
          { itemPrice: this.itemPrices.pricesC, comingFrom: 'USA', items: '9', itemDiscount: '6%' },
          { itemPrice: this.itemPrices.pricesD, comingFrom: 'USA', items: '9', itemDiscount: '6%' },
        ],
        picture: finalImage,
        stockStatus: 'In Stock',
        totalCost: fix_cost_per_unit,
        salesCommission: `$${sales_commission.toFixed(2)}`,
        profitMargin: `${profitMargin.toFixed(2)}`,
        priceAfterDiscount: priceAfterDiscount,
        priceAftertax: priceAftertax,
        totalCostAll: totalCost,
        commissionSales: commissionSales,
        taxes: item_prices_tax.map(tax => ({
          name: tax?.custom_value?.name,
          value: tax?.taxe_value
        }))
      };
  
      // The line's custom-field rows: the item's current rows (GET /item/:id), gaps filled from the
      // line's own rows. Rebuilding from the item response alone dropped what it lacks (its rows
      // carry no field name), so a second Update read "Missing value: Weight" and a line could
      // leave the Product calculations panel (Rod's QA, 2026-10-09).
      result.itemsCustomFields = this.formulaRuntime.withFieldDefinitions(
        FormulaRuntimeService.mergeCustomFieldRows(item?.items_custom_field_datas, this.dailogData?.customFieldsDatas),
      );
      // Custom-field columns only (develop's rule).
      this.formulaRuntime.applyCustomFieldColumns(result, result.itemsCustomFields, (v) => this.formatTimestamp(v));

      return this.formulaRuntime.applyToLine(
        result,
        item,
        result?.Quantity || result?.QTY || item?.unit_quantity || 1,
        formulaFields,
        this.formulaRuntime.quoteImpact(
          String(this.dailogData?.quote_status || this.dailogData?.status || ''),
          this.dailogData?.type !== 'view' && this.dailogData?.type !== 'Quote preview',
        ),
      );
    });
    } catch (err) {
      this.reportItemMappingFailure(err);
      return false;
    }
    this.itemsListArr = tableData;
    this.formulaFieldSums = this.formulaRuntime.rebuildFieldSums(
      this.formulaRuntime.lineItemsFrom(this.itemsListArr),
    );
    return true;
  }

  private reportItemMappingFailure(err: any): void {
    this.logger.log('new-tmp: item mapping failed', err?.message || 'mapping failed');
    if (!this._destroyed && !this.componentDestroyed) {
      this.snackbar.open(
        this.translateService.instant('COMMON.Something went wrong'),
        this.translateService.instant('COMMON.Close'),
        { duration: 4000 },
      );
    }
  }

  private quoteDialogCloseStarted = false;

  private quoteDialogIsOpen(): boolean {
    if (typeof this.dialogRef?.close !== 'function') {
      return false;
    }
    if (typeof this.dialogRef.getState !== 'function') {
      return !this.quoteDialogCloseStarted;
    }
    const state = this.dialogRef.getState() as number | string;
    return state === 0 || state === 'open';
  }

  private closeQuoteDialog(result?: any): void {
    if (this.quoteDialogCloseStarted || !this.quoteDialogIsOpen()) {
      return;
    }
    this.quoteDialogCloseStarted = true;
    try {
      this.dialogRef.close(result);
    } catch (err) {
      this.quoteDialogCloseStarted = false;
      this.logger.log('tableDataItems dialog already closed', err?.message || 'skipped');
    }
  }
  

  async editItemListNew() {
    



    const dialogData: any = {edit:'quotes'};
    dialogData.categoryId = this.itemCategoryId;
    dialogData.itemsEditButtonId = this.itemCategoryId;
    dialogData.id = this.itemNewId;
    if(this.newItemData.isDeactivated=="1"||this.newItemData.isDeactivated==true)dialogData.isDeactivated=true;
    else dialogData.isDeactivated=false;
    const dialogRef = this.dialog.open(AddEditItemComponent, {
      width: "1000px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        if (this.newDiscount) {
          const discountValue = typeof this.newDiscount?.discounts === 'string' ? parseFloat(this.newDiscount?.discounts) : this.newDiscount?.discounts;
          if (!isNaN(discountValue)) {
            dialogResult.item_prices[0].discount = discountValue.toString(); // Update discount
          }
      }
  
      // Check if newPriceA is provided and convert it to a number if it's a string
      console.log(this.newPriceA,'this.newPriceAthis.newPriceA')
      if (this.newPriceA) {
          const priceAValue = this.newPriceA;
              // Parse the price string into an object
              const priceObject = JSON.parse(dialogResult?.item_prices[0]?.price);
  
              // Update pricesA property in the priceObject
              priceObject.pricesA = priceAValue;
  
              // Update the price property with the updated priceObject
              dialogResult.item_prices[0].price = JSON.stringify(priceObject);
          
      }
        let transformedData=[]
        if (dialogResult.tex?.length) {
          transformedData = dialogResult.tex.map(item => ({
              custom_values: { name: item?.taxData ? item?.taxData?.name : item?.name },
              taxe_value: item?.taxe_value
          }));
      }
       
        this.itemsListArr={data:[dialogResult]}
        // The item's "Quantity per Click" (unit_quantity) may have just changed. Reset
        // the line's quantity + step to it so the table reflects the new value (e.g. 5)
        // and the +/- steps by it — rather than keeping the previous quantity (20).
        const perClick = parseInt(dialogResult?.unit_quantity, 10);
        if (!isNaN(perClick) && perClick > 0) {
          this.currentQuantity = perClick;
          this.initialQuantity = perClick;
          this.dailogData.QuantityChange = perClick.toString();
        }
        if (await this.tableDataItemsNew(transformedData)) {
          this.closeQuoteDialog(this.itemsListArr);
        }
      }
    });
  }

  /** Same contract as tableDataItems: true only when itemsListArr holds the mapped lines. */
  async tableDataItemsNew(data:any=[]): Promise<boolean> {
    let formulaFields: any[] | undefined;
    try {
      await this.formulaRuntime.ensureLoaded();
    } catch (err) {
      formulaFields = [];
      this.logger.log('Formula fields failed to load', err?.message || 'load failed');
    }
    if (this._destroyed || this.componentDestroyed) {
      return false;
    }
    try {
      this.formulaRuntime.invalidateFieldSumsCache();
      const sourceRows = Array.isArray(this.itemsListArr?.data) ? this.itemsListArr.data.slice() : null;
      if (!sourceRows) {
        return false;
      }
      const tableData = this.formulaRuntime.syncMapLines(sourceRows, (item) => {
        const selectedImage = this.getSelectedImage(item.item_images);  
        // Extract values from the item object
        const fix_cost_per_unit = parseFloat(item.item_prices[0]?.fix_cost_per_unit) || 0;
        const priceAStringified = item.item_prices[0]?.price as any; // Assuming it's a JSON-stringified string
        const sales_commission = parseFloat(item.item_prices[0]?.sales_commission) || 0;
        const sales_commission_type = item.item_prices[0]?.sales_comm_type;
        const minPrice=  parseFloat(item.item_prices[0]?.min_price) || 0;
    
        let profit = 0;
        let profitMargin = 0;
    
        if (typeof priceAStringified === 'string') {
          try {
            const priceAObj = JSON.parse(priceAStringified);
            console.log(priceAObj,'priceAObjpriceAObjpriceAObjpriceAObj')
            this.itemPrices = JSON.parse(priceAStringified);
            const priceA = priceAObj && priceAObj.pricesA
            ? parseFloat(priceAObj.pricesA.toString().replace(/,/g, '')) || 0
            : 0;
            let discount = 0.00;
            if (item.item_prices[0]?.discount) {
              const discountValue = item.item_prices[0].discount;
              discount = parseFloat(discountValue) / 100 || 0.00;
            }
            const priceAfterDiscount = priceA - (priceA * discount);

            if (priceAfterDiscount > 0) {
              profit = priceAfterDiscount - fix_cost_per_unit;
              profitMargin = (profit * 100) / priceAfterDiscount;
    
              if (sales_commission !== 0 && (sales_commission_type === 2 || sales_commission_type === 1)) {
                if (sales_commission_type === 2) {
                  profit -= profit * (sales_commission / 100); // Subtract as a percentage
                } else {
                  profit -= sales_commission; // Subtract as a direct value
                }
                profitMargin = (profit * 100) / priceAfterDiscount;
              }
            } else {
              profitMargin = 100;
              profit = 100;
            }
          } catch (error) {
            console.error('Error parsing priceAStringified:', error);
          }
        } else {
          profitMargin = 100;
          profit = 100;
        }
    
        const priceAObj = JSON.parse(priceAStringified);
        const price = priceAObj && priceAObj.pricesA
        ? parseFloat(priceAObj.pricesA.toString().replace(/,/g, '')) || 0
        : 0;
              let discount = 1.00;
    
        if (item.item_prices[0]?.discount?.length) {
          const discountValue = Array.isArray(item.item_prices[0].discount) ? item.item_prices[0].discount[0] : item.item_prices[0].discount;
          discount = parseFloat(discountValue.replace('%', '')) / 100 || 0.00;
        }
        let item_prices_tax = data?.length ? data : item.item_prices_taxs;
        let totalTax = 0;

        item_prices_tax.forEach((taxItem) => {
          if (taxItem.taxe_value) {
            let taxValue = 0.0;
            if (typeof taxItem.taxe_value === 'string') {
              taxValue = parseFloat(taxItem.taxe_value.replace('%', '')) / 100 || 0.0;
            } else if (typeof taxItem.taxe_value === 'number') {
              taxValue = taxItem.taxe_value / 100 || 0.0;
            }
            totalTax += taxValue;
          }
        });
    
        let tax = 0.0;
        if (item.item_prices_taxs[0]?.taxe_value) {
          const taxValue = Array.isArray(item.item_prices_taxs[0].taxe_value)
            ? item.item_prices_taxs[0].taxe_value[0]
            : item.item_prices_taxs[0].taxe_value;
          if (typeof taxValue === 'string') {
            tax = parseFloat(taxValue.replace('%', '')) / 100 || 0.0;
          } else if (typeof taxValue === 'number') {
            tax = taxValue / 100 || 0.0;
          }
        }
        const discPrice = price - price * discount;
        
        // Parse quantity
        const quantity = parseInt(this.dailogData?.QuantityChange?this.dailogData?.QuantityChange:item.unit_quantity =='0'?'1':item.unit_quantity, 10);
        const tax_price = (price * tax) * quantity;
        const total_discount = (price * discount) * quantity;
        const perItemTax = price * tax;
        const totalTaxItem = price * totalTax;
        const perItemDisc = price * discount;
        // Calculate totalPrice
        const totalPrice = price * quantity;
        const priceAfterDiscount = totalPrice - total_discount;
        const priceAftertax = totalPrice + tax_price;
        const totalCost = fix_cost_per_unit * quantity;
        const commissionSales = quantity * sales_commission;
    
        const discountArray = item?.item_prices[0]?.discount;
        const firstDiscount = discountArray || 0;
        const discountPercentage = firstDiscount / 100;
        const unitQuantity = item?.unit_quantity || 0;
        const total = (this.parsePrice(priceAStringified) as any) * (unitQuantity as number);
        const description = item?.description ? item.description.replace(/<\/?p>/g, '') : '';
        const description_es = item?.description_es ? item.description_es.replace(/<\/?p>/g, '') : '';
        const description_fr = item?.description_fr ? item.description_fr.replace(/<\/?p>/g, '') : '';
        let result: any = {
          'Applicable taxes': item_prices_tax.map(tax => ({
            name: tax?.custom_values ? tax?.custom_values.name : tax?.custom_value?.name,
            value: tax?.taxe_value
          })).map(tax => `${tax.name} (${tax.value}%)`).join(','),
          Comments:item?.comments?.length? item?.comments?.map((comment) => ({
            id: comment?.id,
            title: comment?.title,
            item_comments: comment?.item_comments,
          })):[],
          Description: description,
          Description_es: description_es,
          Description_fr: description_fr,
          perItemTax: perItemTax,
          minPrice:minPrice,
          totalTaxItem: totalTaxItem,
          inventory: item?.track_inventory || 0,
          perItemDisc: perItemDisc,
          Discount: `${firstDiscount}%`,
          item_type:item?.item_coming_from !==null?item?.item_coming_from:'',
          perItemPrice: price,
          Item_code: item?.code || '',
          Item_image: selectedImage ? this.imageUrl + selectedImage.image : this.staticLogo,
          'Item image': selectedImage ? this.imageUrl + selectedImage.image : this.staticLogo,
          QTY: quantity||1,
          id: item?.id,
          quoteClose:true,
          Quantity: quantity || 1,
          // Carry the item's "Quantity per Click" as the line's +/- step so the table
          // stepper increments/decrements by it (e.g. 5), not by a stale captured value.
          initialQuantity: (!isNaN(parseInt(unitQuantity as any, 10)) && parseInt(unitQuantity as any, 10) > 0) ? parseInt(unitQuantity as any, 10) : (quantity || 1),
          Item_name: item?.name || '',
          applyDiscount: this.newDiscount?.discounts || undefined,
          newAddedPrice: this.newPriceA,
          newPricesArray: this.pricesArrayNew,
          Tax_exempt: item?.item_prices_taxs[0]?.name,
          'Video URL': item?.video_url,
          'Website URL': item?.website_url,
          description: description,
          item: {
            name: item?.name || '',
            description: description,
          },
          Price: this.parsePrice(priceAStringified),
          discount: `${firstDiscount}%`,
          Total: totalPrice || 0,
          discPrice: discPrice.toFixed(2),
          created_at: item.created_at || '',
          category: item?.category?.name,
          categoryId: item?.category?.id?item?.category?.id:item?.categoryId,
          subCategory: item?.subcategory?.name?item?.subcategory?.name:item?.subCategoryId,
          subCategoryId: item?.subcategory?.id,
          Unit: item?.unit || '',
          total_discount: total_discount || 0,
          tax_price: tax_price || 0,
          comments: item?.comments?.map((comment) => ({
            id: comment.id,
            title: comment.title,
            item_comments: comment.item_comments,
          })),
          itemsComing: [
            { itemPrice: this.itemPrices.pricesA, comingFrom: 'Mexico', items: '25', itemDiscount: '5%' },
            { itemPrice: this.itemPrices.pricesB, comingFrom: 'Canada', items: '15', itemDiscount: '8%' },
            { itemPrice: this.itemPrices.pricesC, comingFrom: 'USA', items: '9', itemDiscount: '6%' },
            { itemPrice: this.itemPrices.pricesD, comingFrom: 'USA', items: '9', itemDiscount: '6%' },
          ],
      picture: selectedImage ? this.imageUrl + selectedImage.image : this.staticLogo,
      stockStatus: 'In Stock',
      totalCost: fix_cost_per_unit,
          salesCommission: `$${sales_commission.toFixed(2)}`, 
          profitMargin: `${profitMargin.toFixed(2)}`, 
          priceAfterDiscount: priceAfterDiscount,
          priceAftertax: priceAftertax,
          totalCostAll: totalCost,
          itemsCustomFields:item?.items_custom_field_datas?.length?item?.items_custom_field_datas:[],
          commissionSales: commissionSales,
          taxes: item_prices_tax.map(tax => ({
            name: tax?.custom_values?.name,
            value: tax?.taxe_value
          }))
        };
    
      // Custom-field columns only (develop's rule).
      this.formulaRuntime.applyCustomFieldColumns(result, item?.items_custom_field_datas, (v) => this.formatTimestamp(v));
return this.formulaRuntime.applyToLine(
        result,
        item,
        quantity,
        formulaFields,
        this.formulaRuntime.quoteImpact(
          String(this.dailogData?.quote_status || this.dailogData?.status || ''),
          this.dailogData?.type !== 'view' && this.dailogData?.type !== 'Quote preview',
        ),
      );
  
      });

      this.itemsListArr = tableData;
      this.formulaFieldSums = this.formulaRuntime.rebuildFieldSums(
        this.formulaRuntime.lineItemsFrom(this.itemsListArr),
      );
      return true;
    } catch (error) {
      // develop closed the dialog with the raw { data } object here; now the dialog stays open.
      this.reportItemMappingFailure(error);
      return false;
    }
  }

  tabChanged(tabIndex: number,data:any=''): void {
    if (tabIndex === 1) {
      setTimeout(() => this.signaturePads.resizeCanvas(), 300);
    }
   this.selectedTabIndex = tabIndex; }

   getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  getStatusText(payment: any): string {
    const paidStatuses = ['paid', 'refund', 'void'];
    const currentStatus = (payment?.paymentStatus || payment?.status || '')?.toLowerCase();

    if (paidStatuses.includes(currentStatus)) {
      return currentStatus;
    }

    const paymentDate = new Date(payment?.paymentDate || payment?.selectedDate);
    const currentDate = new Date();
    const today = currentDate.toDateString();
    const paymentDateString = paymentDate.toDateString();

    if (isNaN(paymentDate.getTime())) {
      return currentStatus || 'due';
    }

    if (paymentDate > currentDate) {
      payment.paymentStatus = 'due';
      return 'due';
    }

    if (paymentDateString === today) {
      payment.paymentStatus = 'due today';
      return 'due today';
    }

    payment.paymentStatus = 'past due';
    return 'past due';
  }

  getVisiblePaymentColumns(item?: any) {
    const columns =
      this.paymentDisplayedColumns?.length
        ? this.paymentDisplayedColumns
        : [
            { name: item?.Title || 'Title', key: 'title' },
            { name: item?.Date || 'Date', key: 'paymentDate' },
            { name: item?.Method || 'Method', key: 'paymentMethod' },
            { name: item?.Amount || 'Amount', key: 'paymentAmount' },
            { name: item?.Percentage || 'Percentage', key: 'percentage' },
            { name: 'Status', key: 'paymentStatus' },
          ];

    // Preview is read-only: hide edit/delete and due-checkbox columns.
    return columns.filter(
      (col) => col.key !== 'icon' && col.key !== 'due'
    );
  }

  getVisiblePaymentColumnKeys(item?: any) {
    return this.getVisiblePaymentColumns(item).map((col) => col.key);
  }

  totalDiscount2: any;
  getDiscount(data: any[]): number {
    let discount = 0;
    let perItemDiscount = 0;

    for (const item of data) {
      let perItemDiscount = item?.perItemDisc;
      if (typeof item?.perItemDisc === 'string') {
        perItemDiscount = parseFloat(item.perItemDisc.replace(/,/g, ''));
      }
      let quantity = item['Quantity']
        ? item['Quantity']
        : item['QTY']
        ? item['QTY']
        : item['QUANTITY']?item['QUANTITY']:item['quantity'];
      if (typeof quantity === 'string') {
        quantity = parseFloat(quantity.replace(/,/g, ''));
      }
      if(quantity ==0){
        quantity =1
      }
      discount += perItemDiscount * quantity;
      this.totalDiscount2 = discount;
    }
    if (
      this.rateValue !== undefined &&
      this.rateValue &&
      (this.rateValue !== 0 || this.rateValue !== '0')
    ) {
      discount = discount * this.rateValue;
    }
    return discount;
  }

  isDueNowShow: any;
  getTotal(data: any[]): number {
    const subtotal = this.getSubtotal(data);
    const discount = this.getDiscount(data);
    const tax = this.getTotalTax(data, this.rateValue);
    // this.Total1=subtotal - discount + tax
    this.isDueNowShow = subtotal - discount + tax;

    return subtotal - discount + tax;
  }

  getSubtotal(data: any[]): number {
    let subtotal = 0;
    for (const item of data) {
      let price = item?.perItemPrice;
      if(item?.Total ==0){
        price = 0
      }
      if (item?.perItemPrice) {
        if (typeof item?.perItemPrice == 'string') {
          price = parseFloat(item['Price'].replace(/,/g, ''));
        }
      }
      let quantity = item['Quantity']
        ? item['Quantity']
        : item['QTY']
        ? item['QTY']
        : item['QUANTITY']?item['QUANTITY']:item['quantity'];
      if (typeof quantity === 'string') {
        quantity = parseFloat(quantity.replace(/,/g, ''));
      }
      if(quantity ==0){
        quantity =1
      }
    
      subtotal += price * quantity;
    }
    if (
      this.rateValue !== undefined &&
      this.rateValue &&
      (this.rateValue !== 0 || this.rateValue !== '0')
    ) {
      subtotal = subtotal * this.rateValue;
    }
    // this.grandTotal2=subtotal
    return subtotal;
  }


  getTotalTax(data: any[], rateValue: number): number {
    let totalTaxAmount = 0;

    data.forEach((item) => {
      if (item && item.taxesArray) {
        let perItemPrice
        let quantity = item['Quantity']
        ? item['Quantity']
        : item['QTY']
        ? item['QTY']
        : item['QUANTITY']?item['QUANTITY']:item['quantity'];
        if (typeof quantity === 'string') {
          quantity = parseFloat(quantity.replace(/,/g, ''));
        }
        if(quantity ==0){
          quantity =1
        }
        if(item?.newAddedPrice){
          perItemPrice = parseFloat(item?.newAddedPrice) * quantity;
        }else{
          perItemPrice = parseFloat(item.priceAfterDiscount!==0?item?.priceAfterDiscount:item?.Total);

        }
        if(item?.applyDiscount !==0){
          perItemPrice = parseFloat(item.priceAfterDiscount!==0?item?.priceAfterDiscount:item?.Total)
        }
        if(quantity ==0){
          quantity=1
        }
        const totalPrice = perItemPrice; // Ensure to multiply by quantity
        if (totalPrice > 0) {
          item.taxesArray.forEach((tax) => {
            if (tax.name && tax.value) {
              const taxPercentage = parseFloat(tax.value) / 100;
              const taxAmount = totalPrice * taxPercentage * (rateValue || 1);
              totalTaxAmount += taxAmount;
            }
          });
        }
       
      }
      if (item?.Total <= 0) {
        totalTaxAmount = 0;  // Set totalTaxAmount to 0 when Total is <= 0
    }
    });
   

    return totalTaxAmount;
  }
  aggregateTaxes(
    data: any[],
    rateValue
  ): { [key: string]: { amount: number; percentage: number; value: any } } {
    const aggregatedTaxes: {
      [key: string]: { amount: number; percentage: number; value: any };
    } = {};
    data.forEach((item) => {
      if (item && item.taxesArray) {
        item.taxesArray.forEach((tax) => {
          if (tax.name && tax.value) {
            const taxName = tax.name;
            if (aggregatedTaxes.hasOwnProperty(taxName)) {
              aggregatedTaxes[taxName].value = parseFloat(tax.value);
            } else {
              aggregatedTaxes[taxName] = {
                amount: 0,
                percentage: 0,
                value: parseFloat(tax.value),
              };
            }
          }
        });
      }
    });
    data.forEach((item) => {
      if (item && item.taxesArray) {
        let perItemPrice
        let quantity = item['Quantity']
        ? item['Quantity']
        : item['QTY']
        ? item['QTY']
        : item['QUANTITY']?item['QUANTITY']:item['quantity'];
        if (typeof quantity === 'string') {
          quantity = parseFloat(quantity.replace(/,/g, ''));
        }
        if(quantity ==0){
          quantity =1
        }
        if(item?.newAddedPrice){
          perItemPrice = parseFloat(item?.newAddedPrice) * quantity;

        }else{
          perItemPrice = parseFloat(item.priceAfterDiscount!==0?item?.priceAfterDiscount:item?.Total);

        }
        if(item?.applyDiscount !==0){
          perItemPrice = parseFloat(item.priceAfterDiscount!==0?item?.priceAfterDiscount:item?.Total)
        }
       
        const totalPrice = perItemPrice;
        item.taxesArray.forEach((tax) => {
          if (tax.name && tax.value) {
            const taxName = tax.name;
            const taxPercentage = parseFloat(tax.value) / 100;
            let taxAmount
             taxAmount = totalPrice * taxPercentage * (rateValue || 1);
            if(item?.Total <=0){
              taxAmount=0
            }
            if (aggregatedTaxes.hasOwnProperty(taxName)) {
              aggregatedTaxes[taxName].percentage = parseFloat(tax.value);
              aggregatedTaxes[taxName].amount += taxAmount;

            }
          }
        });
      }
    });
    return aggregatedTaxes;
  }

  userItemPaymentExceeded: boolean = false;
  userTotalItemPayment: boolean = false;


  onFieldChange(fieldName: string, value: any, id: string, name: string,kk) {
    this.actpageIndx=kk
    const index = this.dropListData[this.actpageIndx]?.items.findIndex(
      (droppedItem) => droppedItem?.name === name && droppedItem.id === id
    );

    if (index !== -1) {
      if (fieldName === 'enteredPercentage') {
        value = this.formatPercentagePayment(value);
    }
    if (fieldName === 'enteredAmount') {
      value = this.formatPercentagePayment(value);
  }
      const checkAmountRaw = this.getTotalDue();
      let checkAmount = typeof checkAmountRaw === 'string'
        ? Number(String(checkAmountRaw).replace(/,/g, ''))
        : Number(checkAmountRaw);
      if (isNaN(checkAmount)) checkAmount = 0;
      checkAmount = Number(checkAmount.toFixed(2));
      let newItem = { ...this.dropListData[this.actpageIndx]?.items[index] };

      let enteredAmountValue = parseFloat(newItem.enteredAmount) || 0;
      let enteredPercentageValue = parseFloat(newItem.enteredPercentage) || 0;

      switch (fieldName) {
        case 'selectedPaymentTitle':
          newItem.selectedPaymentTitle = value;
          break;
        case 'selectedDate':
          newItem.selectedDate = moment(value).format().split("T")[0];;
          break;
        case 'selectedPaymentMethod':
          newItem.selectedPaymentMethod = value;
          break;
        case 'enteredAmount':
          enteredAmountValue = parseFloat(value);
          if (!isNaN(enteredAmountValue)) {
            newItem.enteredAmount = Number(enteredAmountValue).toFixed(2);
            const percentage = checkAmount > 0 ? (enteredAmountValue / checkAmount) * 100 : 0;
            newItem.enteredPercentage = percentage.toFixed(2);
          }
          break;
        case 'enteredPercentage':
          enteredPercentageValue = parseFloat(value);
          if (!isNaN(enteredPercentageValue)) {
            newItem.enteredPercentage = Number(enteredPercentageValue).toFixed(2);
            const amount = (enteredPercentageValue / 100) * checkAmount;
            newItem.enteredAmount = amount.toFixed(2);
          }
          break;
        default:
          break;
      }
console.log(this.actpageIndx,'this.actpageIndx')
      this.dropListData[this.actpageIndx].items[index] = newItem;
      let totalPayment = 0;
      this.dropListData[this.actpageIndx].items.forEach((item) => {
        if (item?.name === 'Payment' && item?.enteredAmount) {
          const enteredAmount = parseFloat(item.enteredAmount);
          if (!isNaN(enteredAmount)) {
            totalPayment += enteredAmount;
          }
        }
      });
      totalPayment = Number(totalPayment.toFixed(2));

      if (
        (fieldName === 'enteredAmount' || fieldName === 'enteredPercentage') &&
        totalPayment < checkAmount - 0.01
      ) {
        let newItemCopy = { ...newItem };
        const remainingAmount = checkAmount - totalPayment;
        const remainingPercentage = (remainingAmount / checkAmount) * 100;

        newItemCopy.enteredAmount = remainingAmount.toFixed(2);
        newItemCopy.enteredPercentage = remainingPercentage.toFixed(2);

        delete newItemCopy.selectedPaymentTitle;
        delete newItemCopy.selectedDate;
        delete newItemCopy.selectedPaymentMethod;
        delete newItemCopy.Method;
        delete newItemCopy.Date;
        delete newItemCopy.Title;
        delete newItemCopy.Amount;
        delete newItemCopy.Percentage;

        newItemCopy = {
          ...newItemCopy,
          id: uuidv4(),
        };

        this.dropListData[this.actpageIndx].items.splice(
          index + 1,
          0,
          newItemCopy
        );
      }

      if (totalPayment > checkAmount) {
        this.paymentDialog(
          'Amount Exceeded',
          'The amount you are adding exceeds your total amount'
        );
  
        const exceededIndex = this.dropListData[this.actpageIndx].items.findIndex(
          (droppedItem) => droppedItem?.name === name && droppedItem.id === id
        );
  
        if (exceededIndex !== -1) {
          const item = this.dropListData[this.actpageIndx].items[exceededIndex];
  
          const excessAmount = totalPayment - checkAmount;
          const newEnteredAmount = enteredAmountValue - excessAmount;
          const newEnteredPercentage = (newEnteredAmount / checkAmount) * 100;
  
          item.enteredAmount = newEnteredAmount > 0 ? newEnteredAmount.toFixed(2) : '0';
          item.enteredPercentage = newEnteredPercentage > 0 ? newEnteredPercentage.toFixed(2) : '0';
        }
  
        this.userItemPaymentExceeded = true;
        this.userTotalItemPayment = false;
      } else if (totalPayment === checkAmount) {
        this.userTotalItemPayment = true;
        this.userItemPaymentExceeded = false;
      } else {
        this.userItemPaymentExceeded = false;
      }
    }
  }

  paymentDialog(title, message) {
    let body = {
      title: title,
      message: message,
    };
    const dialogRef = this.dialog.open(templateNotSavingComponent, {
      width: '500px',
      height: '320px',
      data: body,
    });
  }
  
formatPercentagePayment(value: string): string {
  let parsedValue = parseFloat(value);
  if (!isNaN(parsedValue)) {
      return parsedValue.toFixed(2);
  }
  return value;
}

getTotalDue() {
  let totalDue = 0;
  this.tables.forEach((table) => {
    const subtotal = this.getSubtotal(table.data);
    const discount = this.getDiscount(table.data);
    const tax = this.getTotalTax(table.data, this.rateValue);
    totalDue += subtotal - discount + tax;
  });
  let totalObjects = this.dropListData.map((e) =>
    e.items.find((x) => x.name === 'Total Due')
  );
  let totalObjectsDue = this.dropListData.map((e) =>
    e.items.find((x) => x.name === 'Due Now')
  );
  let totalObjectsItem = this.dropListData.map((e) =>
    e.items.find((x) => x.name === 'Item Table')
  );

  if (totalObjects) {
    totalObjects.forEach((totalObject, index) => {
      if (totalObject) {
        const itemIndex = this.dropListData[index].items.findIndex(
          (item: any) =>
            item?.name === totalObject.name && item?.id === totalObject.id
        );
        if (index !== -1) {
          this.dropListData[index].items[itemIndex].dueAmount = totalDue;
        }
      }
    });
  }
  if (totalObjectsDue) {
    totalObjectsDue.forEach((totalObject, index) => {
      if (totalObject) {
        const itemIndex = this.dropListData[index].items.findIndex(
          (item: any) =>
            item?.name === totalObject.name && item?.id === totalObject.id
        );
        if (index !== -1) {
          this.dropListData[index].items[itemIndex].dueAmount = totalDue;
        }
      }
    });
  }
  if (totalObjectsItem) {
    totalObjectsItem.forEach((totalObject, index) => {
      if (totalObject) {
        const itemIndex = this.dropListData[index].items.findIndex(
          (item: any) =>
            item?.name === totalObject.name && item?.id === totalObject.id
        );
        if (index !== -1) {
          this.dropListData[index].items[itemIndex].dueAmount = totalDue;
        }
      }
    });
  }

  this.isDueNowShow = totalDue;
  return totalDue;
}
getSubtotalAfter(data) {
  let subtotal = 0;

  for (const item of data) {
    let quantity = item['Quantity']
    ? item['Quantity']
    : item['QTY']
    ? item['QTY']
    : item['QUANTITY']?item['QUANTITY']:item['quantity'];
    if (typeof quantity === 'string') {
      quantity = parseFloat(quantity.replace(/,/g, ''));
    }
    subtotal += item?.priceAfterDiscount;
  }
  if (
    this.rateValue !== undefined &&
    this.rateValue &&
    (this.rateValue !== 0 || this.rateValue !== '0')
  ) {
    subtotal = subtotal * this.rateValue;
  }

  return subtotal;
}

async activate(cardId) {
  this.sentryService.addBreadcrumb({
    category: 'payment',
    message: 'User clicked Pay button, initiating Stripe payment process',
    level: 'info'
  });
  this.spinnerService.show();
  this.buttonDisabled = true;
  console.log(this.card,'this.cardthis.cardthis.card')
  const stripeResponse = await this.stripe.createToken(this.card).then(function (result) {
    
    if (result.token) {
      localStorage.setItem('cardToken', result.token.id);
      return { error: false, errorMessage: '', token: result.token.id };
    } else {
      return { error: true, errorMessage: result.error.message, token: '' };
    }
  }).then(cardToken => {
    return cardToken;
  });
  if (stripeResponse.error && !cardId) {
    this.stripeToken = '';
    this.errorMessage = stripeResponse.errorMessage;
  } else {
    this.errorMessage = '';
    this.stripeToken = stripeResponse.token;
    this.completeRegistration(stripeResponse.token);
  }
}
upgradeErrorMessage
selectedPlan: any;
extraAddonSelected: any = [];
extraUsers: any = [];


async completeRegistration(cardId) {
  this.upgradeErrorMessage = '';
  this.errorMessage = '';
  const data: any = {};
  data.cardId = cardId;
  data.merchant_id=this.dailogData?.merchantId;
  data.currency=this.dailogData?.currency
  data.currency_id=this.dailogData?.currency_id || this.dailogData?.currency_rate;
  if (this.dailogData?.invoice_id) data.invoice_id = this.dailogData.invoice_id;
  if (this.dailogData?.quote_id) data.quote_id = this.dailogData.quote_id;
  if (this.dailogData?.quote_listing_id) data.quote_listing_id = this.dailogData.quote_listing_id;
  if (this.dailogData?.id) data.id = this.dailogData.id;

  const fallbackId = 
    data.quote_listing_id || 
    data.quote_id || 
    data.invoice_id || 
    data.id ||
    this.dailogData?.paymentsData?.quote_id ||
    this.dailogData?.paymentsData?.id ||
    (typeof this.dailogData?.data === 'object' ? (this.dailogData?.data?.id || this.dailogData?.data?.invoice_id) : null) ||
    this.dailogData?.element?.id ||
    this.dailogData?.element?.Id ||
    this.dailogData?.element?.invoice_id;

  if (!data.quote_listing_id) data.quote_listing_id = fallbackId;
  if (!data.quote_id) data.quote_id = fallbackId;
  if (!data.invoice_id) data.invoice_id = fallbackId;
  if (!data.id) data.id = fallbackId;
  const completeRegistrationSubs = this.QuoteTemplateServices.payment_registration(data).subscribe((val: any) => {
   if(val){
    if (val?.success) {
      // Report exactly which installments this charge settled — the due-now payments of the
      // selected method (their amounts were aggregated into the charge) — so the parent can
      // persist paymentStatus='paid' per payment_id and show each as Paid everywhere.
      const methodName = this.METHOD_NAME_BY_TYPE[this.paymentMethod] || this.paymentMethod;
      const paidPaymentIds = (this.updatedPaymentData || [])
        .filter((p: any) => p?.checked && p?.paymentMethod === methodName)
        .map((p: any) => p?.payment_id)
        .filter(Boolean);
      this.dialogRef.close({ ...val, paidPaymentIds });
    } else {
      this.dialogRef.close(val);
    }
   }
  });
  this.subscriptions.push(completeRegistrationSubs);
}

// Whether a scheduled payment is due now: its date is today or earlier (Due Today + Past Due)
// and it isn't already settled/cancelled. Mirrors QuotePdfViewComponent.isPayableNow so the
// methods offered here match the amount the parent charges. Replaces the old reliance on
// payment.checked, which was frequently unset — leaving this list empty and hiding the Stripe form.
isPayableNow(payment: any): boolean {
  const status = String(payment?.paymentStatus ?? payment?.status ?? '').trim().toLowerCase();
  if (status === 'paid' || status === 'void' || status === 'refund') return false;
  const raw = payment?.paymentDate;
  if (!raw) return false;
  const due = new Date(raw);
  if (isNaN(due.getTime())) return false;
  // Compare by calendar day so a payment dated later *today* still counts as Due Today.
  const now = new Date();
  const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate()).getTime();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return dueDay <= today;
}

// Maps the UI method "type" (used by paymentMehtod / this.paymentMethod) to the stored method name.
private readonly METHOD_NAME_BY_TYPE: { [k: string]: string } = {
  credit: 'Stripe (Credit Card)',
  cash: 'Cash',
  bank: 'Bank Account',
  Visa: 'Visa',
  Master: 'Mastercard',
};

// Reverse of METHOD_NAME_BY_TYPE; custom methods use their own name as the type.
private methodTypeForName(name: string): string {
  const found = Object.keys(this.METHOD_NAME_BY_TYPE).find(t => this.METHOD_NAME_BY_TYPE[t] === name);
  return found || name;
}

// Sum of the due-now payments collected via the given method (accepts a UI type like 'credit'
// or a raw method name). Drives the per-method "Amount to be Paid" as the customer switches
// between method buttons, so each button pays exactly its own method's amount.
amountForMethod(typeOrName: string): number {
  const name = this.METHOD_NAME_BY_TYPE[typeOrName] || typeOrName;
  return (this.updatedPaymentData || [])
    .filter((p: any) => p?.checked && p?.paymentMethod === name)
    .reduce((sum: number, p: any) => sum + (parseFloat(p.paymentAmount) || 0), 0);
}

getUniquePaymentMethods() {
  // Distinct online-collectable methods (checked = card-payable due-now, set in setPaymentFields).
  const uniquePaymentMethods = [];
  const paymentMethodsSet = new Set();

  if (this.updatedPaymentData) {
    for (let i = 0; i < this.updatedPaymentData.length; i++) {
      const payment = this.updatedPaymentData[i];

      if (payment?.checked && !paymentMethodsSet.has(payment?.paymentMethod)) {
        uniquePaymentMethods.push(payment);
        paymentMethodsSet.add(payment?.paymentMethod);
      }
    }
  }

  return uniquePaymentMethods;
}

/** First matching payment row for a method name (avoids duplicate contact-merchant alerts). */
getPaymentByMethodName(methodName: string): any {
  return (this.updatedPaymentData || []).find(
    (payment: any) => payment?.paymentMethod === methodName
  );
}

hasPaymentFields(payment: any): boolean {
  return (payment?.methods || []).some(
    (method: any) => method?.fields?.length > 0
  );
}


rotten_Field(event: any){
  this.rottenDays = event.checked;
  // if(event.checked){
  //   this.addDealStage.controls['rotting_days'].setValue(0);
  // }
  
}
rottenDaysRestrictor(event:any){
  const invalidChars = ['e', '-'];
  if (invalidChars.includes(event.key.toLowerCase())) { event.preventDefault(); }
  // let value = event.target.value;
  // this.leadDealModel.rotting_days = value == 0 ? "0" : value.replace(/^0+/, '');
}

getFormattedCost(): string {
  const cost = parseFloat(this.fixCostUnit) || 0;
  return cost.toFixed(2);
}

getFormattedCommission(): string {
  const commission = parseFloat(this.sales_commission) || 0;
  return commission.toFixed(2);
}

getTotalTaxPercentage(): string {
  if (!this.addItemPriceTaxArr || this.addItemPriceTaxArr.length === 0) {
    return '0';
  }
  const totalPercentage = this.addItemPriceTaxArr.reduce((sum, tax) => {
    return sum + (parseFloat(tax?.taxe_value) || 0);
  }, 0);
  return totalPercentage.toFixed(0);
}

getFormattedTaxAmount(): string {
  const priceA = parseFloat((this.newPriceA || '0').toString().replace(/,/g, '')) || 0;
  if (!this.addItemPriceTaxArr || this.addItemPriceTaxArr.length === 0 || priceA === 0) {
    return '0.00';
  }
  let totalTaxAmount = 0;
  this.addItemPriceTaxArr.forEach((tax) => {
    const taxPercentage = parseFloat(tax?.taxe_value) || 0;
    const taxAmount = (priceA * taxPercentage) / 100;
    totalTaxAmount += taxAmount;
  });
  return totalTaxAmount.toFixed(2);
}

deleteItem(event: MouseEvent): void {
  event.stopPropagation();
  const element = this.dailogData?.element;
  if (!element) {
    return;
  }
  
  const itemDeletedata = {
    title: `Do you want to remove this item? (${element?.itemName || element?.item?.name || 'this item'})`,
    delItemss: true,
  };
  
  const dialogRef = this.dialog.open(MatConfirmDeleteComponent, {
    width: '350px',
    data: itemDeletedata,
  });
  
  dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    if (confirmed) {
      // Close the dialog with delete signal and element data
      this.dialogRef.close({
        delete: true,
        element: element,
        tableIndex: this.dailogData?.tableIndex,
        kk: this.dailogData?.kk
      });
    }
  });
}

getDescriptionColumnName(): string {
  if (this.merchantContactData?.language?.locale === 'es') {
    return 'description_es';
  } else if (this.merchantContactData?.language?.locale === 'fr') {
    return 'description_fr';
  } else {
    return 'description';
  }
}

onDescriptionChange(element: any, event: any): void {
  const newValue = event.target.value;
  // Update the element description directly
  const descriptionKey = this.getDescriptionColumnName();
  element[descriptionKey] = newValue;
}

removeCommentClauses(
  element,
  event,
  type,
  i,
  z,
  item,
  name,
  id,
  comment
) {
  const index1 = element?.fruits?.findIndex(
    (com) => com?.name === comment?.name
  );
  if (index1 >= 0) {
    element.fruits.splice(index1, 1);
    const index = element?.fruits.findIndex(
      (fruit) => fruit.name === comment.name
    );

    if (index >= 0) {
      element?.fruits.splice(index, 1);
    }
  }
}

itemInputChangeClauses(event: Event, element: any[], i: number) {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (value && value !== '') {
    const filterValue = value.toLowerCase();
    this.filteredOptionsClauses = element.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  } else {
    this.resetFilteredOptionsClauses(element);
  }
}

resetFilteredOptionsClauses(element: any[]) {
  this.filteredOptionsClauses = element;
}

addClauses(event: MatChipInputEvent, element: any, i: number): void {
  const value = (event.value || '').trim();

  if (value && !(element?.fruits || []).some((fruit) => fruit.name === value)) {
    const isValuePresent = (element?.custom_value?.value || []).some(
      (comment) => comment.name === value
    );
    element.fruits.push({ name: value, status: 2, id: element.id });
    if (!isValuePresent) {
      element.custom_value.value.push({ name: value, status: 2 });
    }
  }

  event.chipInput!.clear();
  this.searchItem.setValue(null);
  this.resetFilteredOptionsClauses(element.custom_value.value);
}

selectedClauses(
  event: MatAutocompleteSelectedEvent,
  element: any,
  i: number
): void {
  const value = event.option.viewValue;

  if (!(element?.fruits || []).some((fruit) => fruit.name === value)) {
    const isValuePresent = (element?.custom_value?.value || []).some(
      (comment) => comment.name === value
    );
    element.fruits.push({ name: value, status: 2, id: element.id });
    if (!isValuePresent) {
      element.custom_value.value.push({ name: value, status: 2 });
    }
  }

  this.searchItem.setValue(null);
  this.resetFilteredOptionsClauses(element.custom_value.value);
}

isClausePreviewReadonly(): boolean {
  return this.dailogData?.type === 'Quote preview';
}

hide_element(event: any, name: string, id, pageIndex = '') {
  const index = this.dropListData[
    pageIndex !== '' && pageIndex !== undefined ? pageIndex : this.actpageIndx
  ].items.findIndex((item) => item?.name === name && item?.id === id);
  if (index !== -1) {
    this.dropListData[
      pageIndex !== '' && pageIndex !== undefined ? pageIndex : this.actpageIndx
    ].items[index].hidden =
      !this.dropListData[
        pageIndex !== '' && pageIndex !== undefined ? pageIndex : this.actpageIndx
      ].items[index].hidden;
    this.dropListData[
      pageIndex !== '' && pageIndex !== undefined ? pageIndex : this.actpageIndx
    ].items[index].element_hidden =
      !this.dropListData[
        pageIndex !== '' && pageIndex !== undefined ? pageIndex : this.actpageIndx
      ].items[index].element_hidden;
  }
}

}
